/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A opaque and not human readable string representation of a cursor */
  Cursor: { input: string; output: string; }
  /** RFC3339 encoded datetime string i.e 2006-01-02T15:04:05Z07:00 */
  DateTime: { input: string; output: string; }
  /** A scalar html */
  HTML: { input: string; output: string; }
  /** A CSS hex colour code, e.g. #1A2B3C or #ABC */
  HexColorCode: { input: string; output: string; }
  /** A signed JSON Web Token */
  JWT: { input: string; output: string; }
  /** A scalar representing fractional money */
  MoneyInput: { input: string; output: string; }
  /**
   * A scalar representing money in the smallest subunit of the currency (e.g. 150 cents, 1350 dirham).
   * It is always expected to be in the currency of the fund.
   */
  MoneySubUnit: { input: string; output: string; }
  /**
   * A scalar representing money in the full unit of the currency (e.g. 1.50 USD, 1.350 LYD).
   * It is always expected to be in the currency of the fund.
   */
  MoneyUnit: { input: string; output: string; }
  /** A Uniform Resource Locator */
  URL: { input: string; output: string; }
  /** A multipart file upload */
  Upload: { input: any; output: any; }
};

export type AudBankAccountBankAccountLocationDetails = {
  __typename: 'AUDBankAccountBankAccountLocationDetails';
  /** BSB code for Australian bank accounts */
  bsbCode: Scalars['String']['output'];
};

export type AudBankAccountInput = {
  bsbCode: Scalars['String']['input'];
};

export type AudVerifiableBankAccount = VerifiableBankAccount & {
  __typename: 'AUDVerifiableBankAccount';
  accountNumber: Scalars['String']['output'];
  bsbCode: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  status: BankAccountStatus;
};

/** Represents a user account object, with profile information. */
export type Account = {
  __typename: 'Account';
  accountLockedReason?: Maybe<Scalars['String']['output']>;
  /** Returns the active investing entity for the account */
  activeInvestingEntity?: Maybe<InvestingEntity>;
  address?: Maybe<Address>;
  /** The adviser profile attached to this account, if any. */
  adviserProfile?: Maybe<AdviserProfile>;
  /**
   * All notifications across the entities attached to this account (the account itself and its investing
   * entities), paginated and optionally filtered by status.
   */
  allNotificationsForAttachedEntities: AllNotificationsForAttachedEntitiesResult;
  /** The state of this account's authenticator-app second factor. Null when the feature is off or its flag cannot be read, or when the account is not the signed-in one. */
  authenticator?: Maybe<AuthenticatorStatus>;
  /** @deprecated Deprecated remove once no longer in use */
  availableFunds?: Maybe<AccountAvailableFunds>;
  country?: Maybe<Country>;
  created: Scalars['DateTime']['output'];
  dayOfBirth?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailPreferences?: Maybe<EmailPreferences>;
  firstName?: Maybe<Scalars['String']['output']>;
  /** A user is required to provide a minimal set of account details before they can view the bulk of the app */
  hasProvidedAccountDetails: Scalars['Boolean']['output'];
  /** Unique identifier of the Account */
  id: Scalars['ID']['output'];
  /** Returns all investing entities for the account */
  investingEntities?: Maybe<Array<InvestingEntity>>;
  isAccountLocked?: Maybe<Scalars['Boolean']['output']>;
  lastActiveInvestingEntityId?: Maybe<Scalars['ID']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  monthOfBirth?: Maybe<Scalars['Int']['output']>;
  /** Returns a notification for the given type belonging to this account, null if there is no such notification */
  notification?: Maybe<AddInvestingEntityNotification | ConfirmEmailAddressNotification | ConfirmIdentityDocumentDetailsNotification | ProvideCityOfBirthNotification | ReattemptVerifyAddressNotification | ReattemptVerifyBiometricIdentityNotification | VerifyAddressNotification | VerifyBiometricIdentityNotification | VerifyIdentityNotification>;
  /** All notifications for this account, optionaly filtered by status */
  notifications: Array<AddInvestingEntityNotification | ConfirmEmailAddressNotification | ConfirmIdentityDocumentDetailsNotification | ProvideCityOfBirthNotification | ReattemptVerifyAddressNotification | ReattemptVerifyBiometricIdentityNotification | VerifyAddressNotification | VerifyBiometricIdentityNotification | VerifyIdentityNotification>;
  /**
   * Options for populating this account's order-search filters, derived from the
   * account's own orders so the filter values match the orders the portal shows.
   */
  orderSearchOptions: OrderSearchOptions;
  phoneNumber?: Maybe<PhoneNumber>;
  /** @deprecated Deprecated remove once no longer in use */
  placeOfBirth?: Maybe<PlaceOfBirth>;
  preferredName?: Maybe<Scalars['String']['output']>;
  /** @deprecated Deprecated remove once no longer in use */
  primaryCitizenship?: Maybe<Country>;
  /**
   * Searches the account's distribution transactions across its investing entities. When no investing
   * entities are supplied, the search covers all of the account's investing entities. Returned
   * distributions are validated against the account's own set of investing entities.
   */
  searchDistributions: DistributionSearchTransactionResults;
  /**
   * Search documents across the account's entitled investing entities (keyset
   * paginated). Omitting `filters.investingEntityIds` searches all entitled
   * entities. `publishDateFrom`/`publishDateTo` bound the publish date (inclusive).
   * The `FUND`/`UNIT_CLASS` sort fields are not supported.
   */
  searchDocuments: DocumentSearchResults;
  /**
   * Searches the account's holdings across its investing entities. When no investing entities are
   * supplied, the search covers all of the account's investing entities. Returned holdings are
   * validated against the account's own set of investing entities.
   */
  searchHoldings: HoldingSearchResults;
  /** Search across all orders the account is entitled to, optionally scoped by filters. */
  searchOrders: OrderSearchResults;
  /** Search across all transactions the account is entitled to, optionally scoped by filters. */
  searchTransactions: TransactionSearchResults;
  termsAgreed?: Maybe<Scalars['Boolean']['output']>;
  timeZone?: Maybe<Scalars['String']['output']>;
  yearOfBirth?: Maybe<Scalars['Int']['output']>;
};


/** Represents a user account object, with profile information. */
export type AccountAllNotificationsForAttachedEntitiesArgs = {
  associatedRecords?: InputMaybe<Array<AssociatedRecordInput>>;
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  statusFilter?: InputMaybe<NotificationStatus>;
};


/** Represents a user account object, with profile information. */
export type AccountNotificationArgs = {
  type: NotificationType;
};


/** Represents a user account object, with profile information. */
export type AccountNotificationsArgs = {
  status?: InputMaybe<NotificationStatus>;
};


/** Represents a user account object, with profile information. */
export type AccountSearchDistributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  first: Scalars['Int']['input'];
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  holdingId?: InputMaybe<Scalars['ID']['input']>;
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DistributionTransactionSearchSort>;
  statuses?: InputMaybe<Array<DistributionTransactionItemStatus>>;
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Represents a user account object, with profile information. */
export type AccountSearchDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DocumentSearchFiltersV2>;
  first: Scalars['Int']['input'];
  keywords?: InputMaybe<Scalars['String']['input']>;
  publishDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  publishDateTo?: InputMaybe<Scalars['DateTime']['input']>;
  sort?: InputMaybe<DocumentSearchSort>;
};


/** Represents a user account object, with profile information. */
export type AccountSearchHoldingsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['Int']['input'];
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<HoldingSearchSort>;
  statuses?: InputMaybe<Array<HoldingStatus>>;
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Represents a user account object, with profile information. */
export type AccountSearchOrdersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<OrderSearchFilters>;
  first: Scalars['Int']['input'];
  sort?: InputMaybe<OrderSearchSort>;
};


/** Represents a user account object, with profile information. */
export type AccountSearchTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<TransactionSearchFilters>;
  first: Scalars['Int']['input'];
  sort?: InputMaybe<TransactionSearchSort>;
};

export enum AccountAvailableFunds {
  Between_50KAnd_250K = 'BETWEEN_50K_AND_250K',
  Between_250KAnd_1M = 'BETWEEN_250K_AND_1M',
  Over_1M = 'OVER_1M',
  Under_50K = 'UNDER_50K'
}

export type AccountDetailsInput = {
  addressCity: Scalars['String']['input'];
  /** ISO 3166-1 numeric-3 account's address country */
  addressCountry: Scalars['String']['input'];
  addressLine1: Scalars['String']['input'];
  addressPlaceId?: InputMaybe<Scalars['String']['input']>;
  addressPostCode: Scalars['String']['input'];
  /** To capture the raw input from the user, in case the search API results don't match */
  addressRawSearch?: InputMaybe<Scalars['String']['input']>;
  addressSuburb: Scalars['String']['input'];
  callingCode: Scalars['String']['input'];
  consent: Scalars['Boolean']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type AccountFromToken = {
  __typename: 'AccountFromToken';
  accountDetailsVerificationStatus: AccountVerificationStatus;
  firstName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  identityVerificationStatus: AccountVerificationStatus;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
};

/** A notification related to an account */
export type AccountNotification = {
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export enum AccountVerificationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

/** Represents an accreditation for the Investing Entity. */
export type Accreditation = {
  country: Country;
  id: Scalars['ID']['output'];
  updated: Scalars['DateTime']['output'];
};

export enum AccreditationStatus {
  AwaitingStep_2 = 'AWAITING_STEP_2',
  Complete = 'COMPLETE',
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type ActivateAccountInput = {
  password: Scalars['String']['input'];
  termsAgreed: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type AddBankAccountNotification = InvestingEntityNotification & Notification & {
  __typename: 'AddBankAccountNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type AddInvestingEntityDocumentsInput = {
  category: DocumentCategory;
  files: Array<Scalars['Upload']['input']>;
  investingEntityId: Scalars['ID']['input'];
};

export type AddInvestingEntityNotification = AccountNotification & Notification & {
  __typename: 'AddInvestingEntityNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

/** Represents a location. */
export type Address = {
  __typename: 'Address';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  /** Administrative area of the address (e.g. state, province, region) */
  administrativeArea?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country?: Maybe<Country>;
  created: Scalars['DateTime']['output'];
  /** Unique identifier of the Address */
  id: Scalars['ID']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
  postCode?: Maybe<Scalars['String']['output']>;
  status: AddressStatus;
  suburb?: Maybe<Scalars['String']['output']>;
};

export type AddressSearchResult = {
  __typename: 'AddressSearchResult';
  description: Scalars['String']['output'];
  placeId: Scalars['ID']['output'];
};

export type AddressSearchResults = {
  __typename: 'AddressSearchResults';
  results: Array<AddressSearchResult>;
  sessionToken: Scalars['String']['output'];
};

export enum AddressSearchType {
  Address = 'ADDRESS',
  Cities = 'CITIES'
}

export enum AddressStatus {
  Pending = 'PENDING',
  Unverified = 'UNVERIFIED',
  Verified = 'VERIFIED'
}

export type Admin = {
  __typename: 'Admin';
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
};

/** An adviser profile attached to an account. */
export type AdviserProfile = {
  __typename: 'AdviserProfile';
  /** Unique identifier for the adviser profile. */
  id: Scalars['ID']['output'];
  /** Country where the adviser is registered. */
  registrationCountry: Country;
  /** Registration data specific to the registration country. */
  registrationData?: Maybe<AdviserProfileRegistrationData>;
  /** Status of this adviser's Xplan datafeed password. Null when not applicable: the Xplan datafeed portal flag is off, the account is not an adviser, no Xplan adviser code exists or can be derived, or the tenant has no Xplan datafeed table. */
  xplanDatafeedPassword?: Maybe<XplanDatafeedPasswordStatus>;
};

/** Australian-specific registration details for an adviser profile. */
export type AdviserProfileAustralianRegistration = {
  __typename: 'AdviserProfileAustralianRegistration';
  /** AFS Authorised Representative Number issued by ASIC. */
  australianRepresentativeNumber?: Maybe<Scalars['String']['output']>;
};

/** Australian Financial Services adviser registration details. */
export type AdviserProfileAustralianRegistrationInput = {
  /** AFS Authorised Representative Number issued by ASIC. */
  australianRepresentativeNumber: Scalars['String']['input'];
};

/** Adviser registration details carried on CreateAccountInput. Presence signals an adviser sign-up. */
export type AdviserProfileInput = {
  /** ISO 3166-1 numeric-3 country code where the adviser is registered. */
  registrationCountryId: Scalars['ID']['input'];
  /** Country-specific registration data. */
  registrationData: AdviserProfileRegistrationDataInput;
};

/** Registration data for an adviser profile, varying by country. */
export type AdviserProfileRegistrationData = AdviserProfileAustralianRegistration;

/** Country-specific registration data carried on AdviserProfileInput. Exactly one variant must be set. */
export type AdviserProfileRegistrationDataInput = {
  /** Australian registration details. Required when registrationCountryId resolves to AU. */
  australianRegistration?: InputMaybe<AdviserProfileAustralianRegistrationInput>;
};

/** A paginated page of notifications spanning all of an account's attached entities. */
export type AllNotificationsForAttachedEntitiesResult = {
  __typename: 'AllNotificationsForAttachedEntitiesResult';
  /** The notifications for the requested page, each paired with its associated record. */
  notifications: Array<AttachedEntityNotification>;
  /** Total number of notifications matching the filter, ignoring pagination, for rendering an outstanding-notification badge. */
  totalCount: Scalars['Int']['output'];
};

/** Adviser fee values captured against an allocation before issuance. The initial and ongoing legs are each independently optional. */
export type AllocationAdviserFee = {
  __typename: 'AllocationAdviserFee';
  /** Initial advice fee value. Null when no initial fee was captured. */
  initialFee?: Maybe<AllocationAdviserFeeValue>;
  /** Ongoing adviser service fee value. Null when no ongoing fee was captured. */
  ongoingFee?: Maybe<AllocationAdviserFeeValue>;
};

/** Adviser fees for one application. */
export type AllocationAdviserFeeInput = {
  /** A one-off initial advice fee. */
  initialFee?: InputMaybe<AllocationAdviserFeeValueInput>;
  /** An annual ongoing adviser service fee. */
  ongoingFee?: InputMaybe<AllocationAdviserFeeValueInput>;
};

/** A percentage adviser fee rate. */
export type AllocationAdviserFeePercentageInput = {
  /** Number of digits after the decimal point in `value`. */
  decimalPlaces: Scalars['Int']['input'];
  /** Decimal rate between 0 and 1. For example, 0.01 is 1%. */
  value: Scalars['String']['input'];
};

/** A captured adviser fee value: a dollar amount or a percentage. */
export type AllocationAdviserFeeValue = AllocationDollarAdviserFee | AllocationPercentAdviserFee;

/** An adviser fee value. Provide exactly one of `dollar` or `percent`. */
export type AllocationAdviserFeeValueInput = {
  /** A fixed adviser fee. */
  dollar?: InputMaybe<HighPrecisionMoneyInput>;
  /** A percentage rate as a decimal between 0 and 1. For example, 0.01 is 1%. */
  percent?: InputMaybe<AllocationAdviserFeePercentageInput>;
};

/** A dollar-denominated adviser fee. */
export type AllocationDollarAdviserFee = {
  __typename: 'AllocationDollarAdviserFee';
  value: HighPrecisionMoney;
};

/** A percentage adviser fee. */
export type AllocationPercentAdviserFee = {
  __typename: 'AllocationPercentAdviserFee';
  /** Percentage rate as a decimal string between 0 and 1 (e.g. "0.05" = 5%). */
  value: Scalars['String']['output'];
};

export type AllocationRequest = {
  __typename: 'AllocationRequest';
  /** Adviser fee captured against this allocation. Null when no adviser fee was captured. */
  allocationAdviserFee?: Maybe<AllocationAdviserFee>;
  created: Scalars['DateTime']['output'];
  /** Custom field sections responses for the allocation request */
  customFieldSection?: Maybe<Array<CustomFieldSection>>;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  offer: Offer;
  /**
   * The created allocation as a unified cross-entity Order, sourced from the write
   * itself (primary, consistent) so it is immediately consistent with the order
   * that created it. Populated when this allocation is returned from
   * createAllocationRequest; null in other contexts.
   */
  order?: Maybe<Order>;
  /** Reinvestment preferences for the allocation request */
  reinvestmentPreferences?: Maybe<Scalars['Boolean']['output']>;
  /** Requested value for the allocation: either an investment amount (`HighPrecisionMoney`) or a unit count (`FixedPointNumber`). Covers both unit-based and investment-amount-first applications. */
  requestedValue?: Maybe<AllocationRequestedValue>;
  status: AllocationRequestStatus;
};

export enum AllocationRequestStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Requested = 'REQUESTED'
}

export type AllocationRequestedValue = FixedPointNumber | HighPrecisionMoney;

/**
 * Input form of AllocationRequestedValue. Exactly one of `money` or `units` must
 * be provided — `money` for investment-amount allocations, `units` for unit-count
 * allocations.
 */
export type AllocationRequestedValueInput = {
  /** Requested investment amount in HighPrecisionMoney form. */
  money?: InputMaybe<HighPrecisionMoneyInput>;
  /** Requested unit count in FixedPointNumber form. */
  units?: InputMaybe<FixedPointNumberInput>;
};

export type ApplicationProgress = {
  __typename: 'ApplicationProgress';
  activeStep?: Maybe<Scalars['String']['output']>;
  completedSteps: Array<Maybe<Scalars['ID']['output']>>;
  customFieldSections?: Maybe<Array<ApplicationProgressCustomFieldSection>>;
  /**
   * The investor's declared type from the invest-page gate. Drives which document
   * is served and how the Investment Details step behaves. Only populated when
   * WHOLESALE_RETAIL_TYPE is on and the raise has an investorType; null until the
   * investor declares, and cleared when they change their declaration.
   */
  declaredInvestorType?: Maybe<DeclaredInvestorType>;
  /**
   * Which per-type primary document the investor last downloaded. Lets the forced
   * download re-arm when the declaration, and therefore the required document,
   * changes on a WHOLESALE_RETAIL raise. Null on the legacy path and before the
   * first download.
   */
  downloadedOfferDocumentType?: Maybe<OfferPrimaryDocumentType>;
  /**
   * Whether the investor certified they are a wholesale investor at the gate.
   * Populated only for a WHOLESALE declaration; null for a RETAIL declaration,
   * which certifies nothing, and null before the gate is answered.
   */
  hasCertifiedWholesale?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Whether the investor has downloaded the offer document on the legacy
   * single-document path. Only meaningful when the raise has no investorType (or
   * WHOLESALE_RETAIL_TYPE is off); on an investor-type raise the typed
   * downloadedOfferDocumentType is authoritative and this is ignored. Null until
   * the first download.
   */
  hasDownloadedOfferDocument?: Maybe<Scalars['Boolean']['output']>;
  investingEntityId?: Maybe<Scalars['ID']['output']>;
  investmentAmountHPM?: Maybe<ApplicationProgressInvestmentAmount>;
  investorPreference?: Maybe<Scalars['String']['output']>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
};

export type ApplicationProgressCustomFieldSection = {
  __typename: 'ApplicationProgressCustomFieldSection';
  id: Scalars['ID']['output'];
  values?: Maybe<Array<ApplicationProgressCustomFieldSectionValue>>;
};

export type ApplicationProgressCustomFieldSectionValue = {
  __typename: 'ApplicationProgressCustomFieldSectionValue';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ApplicationProgressInvestmentAmount = {
  __typename: 'ApplicationProgressInvestmentAmount';
  amount: Scalars['String']['output'];
  currencyId: Scalars['ID']['output'];
};

/** Details of an asset that is owned by a Fund */
export type Asset = {
  __typename: 'Asset';
  country: Country;
  descriptionBlock: AssetDescriptionBlock;
  galleryImages: Array<Image>;
  id: Scalars['ID']['output'];
  latestKeyMetrics?: Maybe<AssetKeyMetrics>;
  location: Scalars['String']['output'];
  metricsBlock: AssetMetricsBlock;
  name: Scalars['String']['output'];
  optionalCardImageUrl?: Maybe<Scalars['URL']['output']>;
  shortDescription: Scalars['String']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  thumbnailImageUrl: Scalars['URL']['output'];
  vimeoVideoId?: Maybe<Scalars['String']['output']>;
};

export type AssetDescriptionBlock = {
  __typename: 'AssetDescriptionBlock';
  content: Scalars['HTML']['output'];
  title: Scalars['String']['output'];
};

export type AssetKeyMetrics = {
  __typename: 'AssetKeyMetrics';
  effectiveDate: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  landArea: Scalars['Int']['output'];
  latestValuation: Money;
  netLettableArea: Scalars['Int']['output'];
  occupancy: Fraction;
  purchasePrice: Money;
  weightedAverageLeaseTerm: Scalars['Float']['output'];
};

export type AssetMetric = {
  __typename: 'AssetMetric';
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  tooltip: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type AssetMetricsBlock = {
  __typename: 'AssetMetricsBlock';
  /** Metrics may be forecasted as at a specific date. `null` if metrics are 'as at' a date (use `updatedAt`) */
  forecastedAt?: Maybe<Scalars['DateTime']['output']>;
  metrics: Array<AssetMetric>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** Asset structure of a Fund scheme */
export enum AssetStructure {
  MultiAsset = 'MULTI_ASSET',
  SingleAsset = 'SINGLE_ASSET'
}

export type AssociatedAccount = {
  __typename: 'AssociatedAccount';
  access: InvestingEntityAccountAccess;
  email: Scalars['String']['output'];
  /** The IE-targeted email categories this account is subscribed to for the associated investing entity. An empty list means no categories are selected. */
  emailCategories: Array<EmailCategory>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isCommunicationEnabled: Scalars['Boolean']['output'];
  isKeyAccount: Scalars['Boolean']['output'];
  lastName: Scalars['String']['output'];
};

/** References a specific record to scope a notification query to. */
export type AssociatedRecordInput = {
  /** The identifier of the record. */
  id: Scalars['ID']['input'];
  /** The kind of record being referenced. */
  recipientType: RecipientType;
};

/** A notification paired with the record it is associated with, for cross-entity listing. */
export type AttachedEntityNotification = {
  __typename: 'AttachedEntityNotification';
  /** The record the notification is associated with. */
  associatedRecord: NotificationAssociatedRecord;
  /** The notification itself. */
  notification: AddBankAccountNotification | AddInvestingEntityNotification | ConfirmAccreditationNotification | ConfirmEmailAddressNotification | ConfirmIdentityDocumentDetailsNotification | ConfirmUnsupportedCountryAccreditationNotification | ProvideBeneficialOwnerContactDetailsNotification | ProvideCityOfBirthNotification | ProvideInvestingEntityDocumentsNotification | ProvideSourceOfFundsNotification | ReattemptConfirmAccreditationNotification | ReattemptProvideSourceOfFundsNotification | ReattemptVerifyAddressNotification | ReattemptVerifyBiometricIdentityNotification | RenewAccreditationNotification | VerifyAddressNotification | VerifyBankAccountNotification | VerifyBiometricIdentityNotification | VerifyIdentityNotification;
};

/** The state of an account's authenticator-app second factor. */
export type AuthenticatorStatus = {
  __typename: 'AuthenticatorStatus';
  /** How many backup codes are left unspent. */
  backupCodesRemaining: Scalars['Int']['output'];
  /** True once an enrolment is active. A started but unconfirmed enrolment is not enrolled. */
  enrolled: Scalars['Boolean']['output'];
  /** When the user first proved possession of the secret. Null while not enrolled. */
  enrolledAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AutoReInvestmentTransaction = Transaction & {
  __typename: 'AutoReInvestmentTransaction';
  amount: Money;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  pricePerUnit: Money;
  processedAt: Scalars['DateTime']['output'];
  reference?: Maybe<Scalars['String']['output']>;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling) */
  tags?: Maybe<Array<TransactionTag>>;
  to?: Maybe<Fund>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
};

export type AutocompleteAddressInput = {
  placeId: Scalars['String']['input'];
  rawSearch: Scalars['String']['input'];
};

/**
 * Backup codes for the account. Shown once and never retrievable again; only the
 * remaining count is readable afterwards.
 */
export type BackupCodesPayload = {
  __typename: 'BackupCodesPayload';
  /** The recovery codes, each spendable once in place of an authenticator code. */
  codes: Array<Scalars['String']['output']>;
  /** The name to save the codes under, e.g. `Backup Codes - Jane Smith - 2026-09-18.txt`. */
  fileName: Scalars['String']['output'];
};

/** Represents a bank account */
export type BankAccount = {
  __typename: 'BankAccount';
  accountNumber: Scalars['String']['output'];
  bsbCode?: Maybe<Scalars['String']['output']>;
  currency: Currency;
  id: Scalars['ID']['output'];
  locked: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  routingNumber?: Maybe<Scalars['String']['output']>;
  ukSortCode?: Maybe<Scalars['String']['output']>;
};

export type BankAccountLocationDetails = AudBankAccountBankAccountLocationDetails | GbpBankAccountBankAccountLocationDetails | UsdBankAccountBankAccountLocationDetails;

export type BankAccountLocationDetailsInput = {
  audBankAccount?: InputMaybe<AudBankAccountInput>;
  gbpBankAccount?: InputMaybe<GbpBankAccountInput>;
  usdBankAccount?: InputMaybe<UsdBankAccountInput>;
};

export enum BankAccountStatus {
  Declined = 'DECLINED',
  Pending = 'PENDING',
  Verified = 'VERIFIED'
}

/**
 * A lightweight projection of a holding. Surfaces only the fields needed to display existing holdings per
 * investing entity and excludes the heavier rollups (returns, plot points,
 * totals) computed by the full `Holding` type.
 */
export type BaseHolding = {
  __typename: 'BaseHolding';
  /** Fund the holding belongs to. */
  fund: Fund;
  /** Unique identifier of the holding. */
  id: Scalars['ID']['output'];
  /** Marked value of the holding. */
  markedValue: HighPrecisionMoney;
  /** Unit class the holding is in. */
  unitClass: UnitClass;
};

export type BeginIdentityVerificationInput = {
  id: Scalars['ID']['input'];
  identityVerificationType: IdentityVerificationType;
  /** Token passed if we are verifying an unauthenticated account */
  token?: InputMaybe<Scalars['String']['input']>;
};

export type BeginIdentityVerificationResponse = {
  __typename: 'BeginIdentityVerificationResponse';
  sdkToken: Scalars['String']['output'];
  workflowRunId: Scalars['String']['output'];
};

export type BeneficialOwner = {
  __typename: 'BeneficialOwner';
  address?: Maybe<Address>;
  addressVerificationStatus: BeneficialOwnerVerificationStatus;
  basicDetailsVerificationStatus: BeneficialOwnerVerificationStatus;
  biometricIdentityVerificationStatus: BeneficialOwnerVerificationStatus;
  email: Scalars['String']['output'];
  /** FATCA/CRS details for this beneficial owner, if captured */
  fatcaCrsDetails?: Maybe<FatcaCrsDetails>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  identityDocumentVerificationStatus: BeneficialOwnerVerificationStatus;
  /** @deprecated no longer supported */
  investingEntityName?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer supported */
  investingEntityPrimaryOwnerFirstName?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer supported */
  investingEntityPrimaryOwnerLastName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  /** Tax residencies on file for this beneficial owner, if captured */
  taxDetails?: Maybe<BeneficialOwnerTaxDetails>;
};

export type BeneficialOwnerContact = {
  __typename: 'BeneficialOwnerContact';
  dateOfBirth?: Maybe<DayMonthYear>;
  email?: Maybe<Scalars['String']['output']>;
  /** @deprecated no longer supported */
  entityName?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<PhoneNumber>;
  /** @deprecated use relationships instead */
  relationship?: Maybe<BeneficialOwnerContactRelationship>;
  relationships?: Maybe<Array<BeneficialOwnerContactRelationship>>;
};

export type BeneficialOwnerContactDetailsInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  mobilePhone?: InputMaybe<PhoneNumberInput>;
};

export enum BeneficialOwnerContactRelationship {
  AppointorOrProtector = 'APPOINTOR_OR_PROTECTOR',
  BearerAndNomineeShareholder = 'BEARER_AND_NOMINEE_SHAREHOLDER',
  BeneficiaryGreaterThan_25Percent = 'BENEFICIARY_GREATER_THAN_25_PERCENT',
  Director = 'DIRECTOR',
  DiscretionaryBeneficiary = 'DISCRETIONARY_BENEFICIARY',
  ExecutorOrAdministrator = 'EXECUTOR_OR_ADMINISTRATOR',
  GeneralPartner = 'GENERAL_PARTNER',
  LimitedPartnerGreaterThan_25Percent = 'LIMITED_PARTNER_GREATER_THAN_25_PERCENT',
  MigratedAccount = 'MIGRATED_ACCOUNT',
  NomineeShareholder = 'NOMINEE_SHAREHOLDER',
  NonDiscretionaryBeneficiary = 'NON_DISCRETIONARY_BENEFICIARY',
  OtherAuthorisedParty = 'OTHER_AUTHORISED_PARTY',
  Partner = 'PARTNER',
  PowerOfAttorney = 'POWER_OF_ATTORNEY',
  Settlor = 'SETTLOR',
  ShareholdingVotingRightsGreaterThan_25Percent = 'SHAREHOLDING_VOTING_RIGHTS_GREATER_THAN_25_PERCENT',
  Trustee = 'TRUSTEE'
}

/**
 * FATCA/CRS details for individual beneficial owners / related parties.
 * Contains only the fields relevant to individuals — entity-specific fields
 * (GIIN, FATCA classification, etc.) are captured via the Admin App.
 */
export type BeneficialOwnerFatcaCrsDetailsInput = {
  /** Whether the person has made a FATCA/CRS declaration */
  fatcaCrsDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this person is a US person for tax purposes */
  isUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** US tax identification number if the person is a US person */
  usTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Tax residencies on file for an individual beneficial owner / related party.
 * Tax identification numbers are redacted to "Provided" / "Not Provided" — the
 * full value never reaches the investor portal, so a redacted value must never
 * be written back as data.
 */
export type BeneficialOwnerTaxDetails = {
  __typename: 'BeneficialOwnerTaxDetails';
  /** Canonical entity-service exemption reason for the primary residency, when no real tax identifier is provided. */
  primaryTaxExemptReason?: Maybe<Scalars['String']['output']>;
  /** Redacted primary tax identification number. */
  primaryTaxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  /** Country where the beneficial owner is a primary tax resident. */
  primaryTaxResidencyCountry?: Maybe<Country>;
  /** Canonical entity-service exemption reason for the secondary residency, when no real tax identifier is provided. */
  secondaryTaxExemptReason?: Maybe<Scalars['String']['output']>;
  /** Redacted secondary tax identification number. */
  secondaryTaxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  /** Country where the beneficial owner is a secondary tax resident. */
  secondaryTaxResidencyCountry?: Maybe<Country>;
};

/**
 * Tax residencies for an individual beneficial owner / related party.
 * Related parties on the investor portal are individuals, so this carries
 * residencies only — prescribed investor rate and withholding tax rates are
 * held against investing entities, not related parties.
 */
export type BeneficialOwnerTaxDetailsInput = {
  /** Entity-service exemption reason for the primary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  primaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Primary tax identification number for the beneficial owner. */
  primaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the beneficial owner is a primary tax resident. */
  primaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** Entity-service exemption reason for the secondary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  secondaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Secondary tax identification number for the beneficial owner. */
  secondaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the beneficial owner is a secondary tax resident. */
  secondaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BeneficialOwnerVerificationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE',
  Pending = 'PENDING'
}

/** Adviser fees for one bulk application item. Each fee is optional. */
export type BulkAllocationAdviserFeeInput = {
  /** A one-off initial advice fee. */
  initialFee?: InputMaybe<AllocationAdviserFeeValueInput>;
  /** An annual ongoing adviser service fee. */
  ongoingFee?: InputMaybe<AllocationAdviserFeeValueInput>;
};

/** A single entry in a bulk allocation request — one investing entity and the value to allocate to it. */
export type BulkCreateAllocationRequestEntryInput = {
  /** Adviser fees for this application. Zero-valued fees are omitted. */
  adviserFee?: InputMaybe<BulkAllocationAdviserFeeInput>;
  /** Investing entity the allocation request is placed on behalf of. */
  investingEntityId: Scalars['ID']['input'];
  /** Whether distributions for this application should be reinvested. */
  reinvestmentPreference?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requested value for this item's allocation. */
  requestedValue: AllocationRequestedValueInput;
};

/** Failure result of a bulk allocation request — the whole batch was rolled back. */
export type BulkCreateAllocationRequestFailureResult = {
  __typename: 'BulkCreateAllocationRequestFailureResult';
  /** Per-item failure payloads. Ordered to match `input.items`. */
  payloads: Array<BulkCreateAllocationRequestItemFailurePayload>;
};

/**
 * Per-item failure payload from a failed bulk allocation request. The
 * `errorMessage` is populated only when this investing entity was a cause of the
 * batch failing — items dragged along by atomic rollback have `errorMessage`
 * left null.
 */
export type BulkCreateAllocationRequestItemFailurePayload = {
  __typename: 'BulkCreateAllocationRequestItemFailurePayload';
  /** Reason this investing entity caused the batch to fail. Null when this entity was not a cause. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** Investing entity this payload corresponds to. */
  investingEntityId: Scalars['ID']['output'];
};

/**
 * Response shape for `bulkCreateAllocationRequests`. Either every item succeeded
 * (`BulkCreateAllocationRequestSuccessResult`, carrying the created allocation requests)
 * or the whole batch failed (`BulkCreateAllocationRequestFailureResult`, carrying a
 * per-item list of failure payloads).
 */
export type BulkCreateAllocationRequestPayload = BulkCreateAllocationRequestFailureResult | BulkCreateAllocationRequestSuccessResult;

/** Successful result of a bulk allocation request — one created allocation request per item in the input. */
export type BulkCreateAllocationRequestSuccessResult = {
  __typename: 'BulkCreateAllocationRequestSuccessResult';
  /** The allocation requests created by the batch, one per item in the input. */
  allocationRequests: Array<AllocationRequest>;
  /**
   * The created allocation requests as unified cross-entity Orders, one per item in
   * the input, sourced from the write itself (primary, consistent).
   */
  orders: Array<Order>;
};

/** Input for the adviser bulk-application flow. */
export type BulkCreateAllocationRequestsInput = {
  /**
   * The applicant's self-declared investor classification, applying to every entry
   * in the batch. One declaration per batch: an adviser runs a separate batch per
   * investor type, so a batch never mixes them.
   */
  declaredInvestorType?: InputMaybe<DeclaredInvestorType>;
  /** `null` if not required - if the offer doesn't require accreditation. Applies to the whole batch. */
  hasAcknowledgedAccreditationIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  /** Single confirmation that the offer documentation has been read, covering the whole batch. */
  hasConfirmedReadDocumentation: Scalars['Boolean']['input'];
  /** Per-investing-entity allocation entries. Must contain at least one entry. */
  items: Array<BulkCreateAllocationRequestEntryInput>;
  /** Offer all allocation requests are placed against. */
  offerId: Scalars['ID']['input'];
};

export type BulkDownloadDocumentsInput = {
  documents: Array<DocumentToDownload>;
  /** @deprecated Ignored. The zip is named 'Documents - {Account Full Name} - {YYYY-MM-DD}.zip'. */
  zipFilename?: InputMaybe<Scalars['String']['input']>;
};

export type BulkDownloadDocumentsResult = {
  __typename: 'BulkDownloadDocumentsResult';
  /** Presigned S3 URL. Browser triggers download via window.location. */
  downloadUrl: Scalars['URL']['output'];
  /** Number of documents actually written into the zip (input count minus skipped). */
  includedCount: Scalars['Int']['output'];
  /** Documents that could not be included. Empty when all input documents succeeded. */
  skippedDocuments: Array<SkippedDocument>;
  /** The filename the browser will save as, e.g. 'Documents - Jane Smith - 2026-05-11.zip'. */
  zipFilename: Scalars['String']['output'];
};

/** Cross-entity variant of `BulkDownloadDocumentsInput`. */
export type BulkDownloadDocumentsV2Input = {
  documents: Array<DocumentToDownload>;
  /** Optional. Subset of the caller's entitled entities; empty spans all. */
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Ignored. The zip is named 'Documents - {Account Full Name} - {YYYY-MM-DD}.zip'. */
  zipFilename?: InputMaybe<Scalars['String']['input']>;
};

export type BuyOrder = {
  __typename: 'BuyOrder';
  bidPrice: Money;
  created: Scalars['DateTime']['output'];
  fund: Fund;
  id: Scalars['ID']['output'];
  status: BuyOrderStatus;
  totalValue: Money;
  unitCountDecimal: FixedPointNumber;
};

export enum BuyOrderStatus {
  AwaitingTransfer = 'AWAITING_TRANSFER',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Placed = 'PLACED'
}

/** A capital-raise (offer) custom-field section: the section plus its offer-scoped visibility. */
export type CapitalRaiseCustomSection = {
  __typename: 'CapitalRaiseCustomSection';
  /** Which investor classification this section targets. */
  investorType: CustomFieldSectionInvestorType;
  /** Whether this section is hidden from advisers in the investor portal. */
  isHiddenForAdviser: Scalars['Boolean']['output'];
  /** The underlying custom-field section. */
  section: CustomFieldSection;
};

export enum ChartAggregationStatistic {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Last = 'LAST',
  Max = 'MAX',
  Min = 'MIN',
  Sum = 'SUM'
}

export enum ChartRollup {
  Annual = 'ANNUAL',
  Day = 'DAY',
  Month = 'MONTH'
}

export type CompanyInvestingEntity = {
  __typename: 'CompanyInvestingEntity';
  /** Registered address of the company */
  address?: Maybe<Address>;
  /** Business number of the company */
  businessNumber?: Maybe<Scalars['String']['output']>;
  /** Company type */
  companyType?: Maybe<InvestingEntityCompanyType>;
  /** Get FATCA/CRS details for an investing entity, joint individual, or related party. Provide exactly one target. */
  fatcaCrsDetails?: Maybe<FatcaCrsDetails>;
  /** Unique identifier for this company investing entity. */
  id: Scalars['ID']['output'];
  /** Legal name of the company */
  name?: Maybe<Scalars['String']['output']>;
  /** Nature and purpose details for the company */
  natureAndPurposeDetails?: Maybe<NatureAndPurposeDetails>;
  /** Company Registration Number */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Entity tax details */
  taxDetails?: Maybe<EntityTaxDetails>;
};

/** Represents a company search result. */
export type CompanyResult = {
  __typename: 'CompanyResult';
  countryId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CompleteAccountIdentityVerificationInput = {
  /** Token passed if we are verifying an unauthenticated account */
  token?: InputMaybe<Scalars['String']['input']>;
  workflowRunId: Scalars['ID']['input'];
};

export type CompleteBeneficialOwnerContactDetailsInput = {
  contactDetails: Array<BeneficialOwnerContactDetailsInput>;
};

export type CompleteBeneficialOwnerIdentityVerificationInput = {
  /** Token passed in query string from email link */
  token: Scalars['String']['input'];
  workflowRunId: Scalars['ID']['input'];
};

export type ConfirmAccreditationInput = {
  /** ISO 3166-1 numeric-3 of the investing entity's tax residency country */
  country: Scalars['ID']['input'];
  /** Document uploaded to support the accreditation */
  file: Scalars['Upload']['input'];
  /** The ID of the investing entity that this accreditation is confirmed against */
  id: Scalars['ID']['input'];
};

export type ConfirmAccreditationNotification = InvestingEntityNotification & Notification & {
  __typename: 'ConfirmAccreditationNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

/** Proves possession of the secret returned by startAuthenticatorEnrolment. */
export type ConfirmAuthenticatorEnrolmentInput = {
  /** The account's current password, re-proved before the enrolment activates. */
  password: Scalars['String']['input'];
  /** A six-digit code from the authenticator app. A backup code is not accepted: none has been issued yet. */
  totpCode: Scalars['String']['input'];
};

export type ConfirmBeneficialOwnerIdentityDocumentDetailsInput = {
  /** enum one of: '554', '36' */
  country: Scalars['ID']['input'];
  /** Date of birth information */
  dateOfBirth: DayMonthYearInput;
  /** The legal first name of the account holder */
  firstName: Scalars['String']['input'];
  /**
   * ## Required Fields:
   * - If country = NZ and type = passport
   *     - number
   *     - expiry - ISO 8601 Date
   * - If country = NZ and type = driver_licence
   *     - number
   *     - version
   * - If country = AU and type = passport
   *     - number
   *     - gender
   *         - enum one of: 'M', 'F', 'X'
   * - If country = AU and type = driver_licence
   *     - number
   *     - state
   *         - enum one of: 'ACT', 'NSW', 'NT', 'QLD', 'SA', 'TAS', 'VIC', 'WA'
   * - Else `ErrorInvalidArgument`
   */
  identityDocumentFields: Array<IdentityDocumentFieldInput>;
  /** The legal last name of the account holder */
  lastName: Scalars['String']['input'];
  /** The legal middle name of the account holder */
  middleName?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  type: IdentityDocumentType;
};

export type ConfirmEmailAddressNotification = AccountNotification & Notification & {
  __typename: 'ConfirmEmailAddressNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ConfirmIdentityDocumentDetailsNotification = AccountNotification & Notification & {
  __typename: 'ConfirmIdentityDocumentDetailsNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ConfirmUnsupportedCountryAccreditationNotification = InvestingEntityNotification & Notification & {
  __typename: 'ConfirmUnsupportedCountryAccreditationNotification';
  country: Country;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

/** Represents a country object. */
export type Country = {
  __typename: 'Country';
  callingCode: Scalars['String']['output'];
  emoji?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isoAlpha2: Scalars['String']['output'];
  isoAlpha3: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type CreateAccountInput = {
  /** Adviser registration details. Provide this to sign up as an adviser; omit for the existing investor sign-up path. */
  adviserProfile?: InputMaybe<AdviserProfileInput>;
  /** Auto complete address of the account holder */
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** Manual address of the account holder */
  manualAddress?: InputMaybe<ManualAddressInput>;
  password: Scalars['String']['input'];
  /** Phone number of the account holder */
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  termsAgreed: Scalars['Boolean']['input'];
};

export type CreateAllocationRequestInput = {
  /** The adviser's email when isAdvised is true. */
  adviserEmail?: InputMaybe<Scalars['String']['input']>;
  /** Adviser fees for this application. Zero-valued fees are omitted. */
  adviserFee?: InputMaybe<AllocationAdviserFeeInput>;
  /** The applicant's self-declared investor classification. */
  declaredInvestorType?: InputMaybe<DeclaredInvestorType>;
  /** `null` if not required - if offer doesn't require accreditation, or if the investor is accredited */
  hasAcknowledgedAccreditationIsRequired?: InputMaybe<Scalars['Boolean']['input']>;
  hasConfirmedReadDocumentation: Scalars['Boolean']['input'];
  investingEntityId: Scalars['ID']['input'];
  /** Whether the applicant is being advised by a financial adviser on this application. */
  isAdvised?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['String']['input']>;
  offerId: Scalars['ID']['input'];
  /** Reinvestment preferences for the allocation request */
  reinvestmentPreference?: InputMaybe<Scalars['Boolean']['input']>;
  /** Requested value for the allocation — either an investment amount or a unit count. Use instead of `unitCountDecimal`. */
  requestedValue?: InputMaybe<AllocationRequestedValueInput>;
  /** Responses to custom fields associated with this allocation request */
  sections?: InputMaybe<Array<CustomFieldSectionInput>>;
  /**
   * Number of units in the allocation. Provide exactly one of `unitCountDecimal` or `requestedValue`.
   * @deprecated Use `requestedValue` instead
   */
  unitCountDecimal?: InputMaybe<FixedPointNumberInput>;
};

export type CreateBankAccountInput = {
  /** Account number for the bank account */
  accountNumber: Scalars['String']['input'];
  /** Currency specific details for the bank account */
  bankAccountLocationDetails?: InputMaybe<BankAccountLocationDetailsInput>;
  /** ISO 3166-1 numeric-3 of the country where the bank account is held */
  countryId?: InputMaybe<Scalars['ID']['input']>;
  /** ISO 4217 currency code for the bank account */
  currencyCode: Scalars['String']['input'];
  /** File containing the bank statement or proof of ownership */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of the investing entity to which this bank account belongs */
  investingEntityId: Scalars['ID']['input'];
  /** Name of the bank account holder */
  name: Scalars['String']['input'];
  /** Nickname for the bank account */
  nickname: Scalars['String']['input'];
  /** SWIFT/BIC code for the bank account */
  swiftBic?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyInvestingEntityInput = {
  /** Auto complete registered address of the company */
  autocompleteRegisteredAddress?: InputMaybe<AutocompleteAddressInput>;
  /** Business number of the company */
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  /** Name of the company */
  companyName: Scalars['String']['input'];
  /** Company Registration Number */
  companyRegistrationNumber: Scalars['String']['input'];
  /** Company type */
  companyType: InvestingEntityCompanyType;
  /** FATCA/CRS details for the company */
  fatcaCrsDetails?: InputMaybe<FatcaCrsDetailsInput>;
  /** RWT rate on interest */
  interestResidentWithholdingTax?: InputMaybe<ResidentWithholdingTaxRateBasisPoints>;
  /** Manual registered address of the company */
  manualRegisteredAddress?: InputMaybe<ManualAddressInput>;
  /** nature and purpose details for the company */
  natureAndPurpose?: InputMaybe<CreateNatureAndPurposeInput>;
  /** NZ PIR */
  nzPrescribedInvestorRate?: InputMaybe<NzPrescribedInvestorRateBasisPoints>;
  /** Entity-service exemption reason for the primary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  primaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Primary tax identification number for the investing entity. */
  primaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a primary tax resident. */
  primaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** Entity-service exemption reason for the secondary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  secondaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Secondary tax identification number for the investing entity. */
  secondaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a secondary tax resident. */
  secondaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateIndividual = {
  /** Auto complete address of the individual */
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  /** Date of birth of the individual */
  dateOfBirth?: InputMaybe<DayMonthYearInput>;
  /** Email address of the individual required if second individual on joint individual */
  email?: InputMaybe<Scalars['String']['input']>;
  /** FATCA/CRS details for the individual */
  fatcaCrsDetails?: InputMaybe<FatcaCrsDetailsInput>;
  /** First name of the individual */
  firstName: Scalars['String']['input'];
  /** RWT rate on interest */
  interestResidentWithholdingTax?: InputMaybe<ResidentWithholdingTaxRateBasisPoints>;
  /** Last name of the individual */
  lastName: Scalars['String']['input'];
  /** Manual address of the individual */
  manualAddress?: InputMaybe<ManualAddressInput>;
  /** Middle name of the individual */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** nature and purpose details for the individual */
  natureAndPurpose?: InputMaybe<CreateNatureAndPurposeInput>;
  /** NZ PIR */
  nzPrescribedInvestorRate?: InputMaybe<NzPrescribedInvestorRateBasisPoints>;
  /** Phone number of the individual */
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  /** Place of birth details of the individual */
  placeOfBirthCity?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 of the individual's place of birth */
  placeOfBirthCountry?: InputMaybe<Scalars['String']['input']>;
  placeOfBirthPlaceId?: InputMaybe<Scalars['String']['input']>;
  placeOfBirthRawSearch?: InputMaybe<Scalars['String']['input']>;
  /** Primary citizenship of the individual */
  primaryCitizenshipId: Scalars['ID']['input'];
  /** Entity-service exemption reason for the primary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  primaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Primary tax identification number for the investing entity. */
  primaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a primary tax resident. */
  primaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** Entity-service exemption reason for the secondary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  secondaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Secondary tax identification number for the investing entity. */
  secondaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a secondary tax resident. */
  secondaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateIndividualInvestingEntityInput = {
  /** details of the individual */
  individual: CreateIndividual;
};

export type CreateJointIndividualInvestingEntityInput = {
  /** individual one */
  individualOne: CreateIndividual;
  /** individual two */
  individualTwo: CreateIndividual;
};

export type CreateNatureAndPurposeInput = {
  /** Estimate of Funds Available for Investment */
  availableFunds?: InputMaybe<InvestingEntityAvailableFunds>;
  /** The frequency of investment expected from the Investing Entity */
  frequencyOfInvestment?: InputMaybe<InvestingEntityFrequencyOfInvestment>;
  /** The reason for investing */
  reasonForInvesting?: InputMaybe<InvestingEntityReasonForInvesting>;
  /** source of funds */
  sourceOfFunds?: InputMaybe<SourceOfFundsSource>;
};

export type CreatePartnershipInvestingEntityInput = {
  /** Auto complete registered address of the partnership */
  autocompleteRegisteredAddress?: InputMaybe<AutocompleteAddressInput>;
  /** Business number of the partnership */
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  /** FATCA/CRS details for the partnership */
  fatcaCrsDetails?: InputMaybe<FatcaCrsDetailsInput>;
  /** RWT rate on interest */
  interestResidentWithholdingTax?: InputMaybe<ResidentWithholdingTaxRateBasisPoints>;
  /** Manual registered address of the partnership */
  manualRegisteredAddress?: InputMaybe<ManualAddressInput>;
  /** nature and purpose details for the partnership */
  natureAndPurpose?: InputMaybe<CreateNatureAndPurposeInput>;
  /** NZ PIR */
  nzPrescribedInvestorRate?: InputMaybe<NzPrescribedInvestorRateBasisPoints>;
  /** partnership documents */
  partnershipDocuments: Array<Scalars['Upload']['input']>;
  /** name of the partnership */
  partnershipName: Scalars['String']['input'];
  /** partnership type */
  partnershipType: InvestingEntityPartnershipType;
  /** Entity-service exemption reason for the primary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  primaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Primary tax identification number for the investing entity. */
  primaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a primary tax resident. */
  primaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** registration number of the partnership (if applicable) */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Entity-service exemption reason for the secondary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  secondaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Secondary tax identification number for the investing entity. */
  secondaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a secondary tax resident. */
  secondaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateSessionFromTokenInput = {
  token: Scalars['String']['input'];
};

export type CreateSessionInput = {
  email: Scalars['String']['input'];
  isRememberMeEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  password: Scalars['String']['input'];
};

export type CreateTrustInvestingEntityInput = {
  /** Auto complete registered address of the company */
  autocompleteRegisteredAddress?: InputMaybe<AutocompleteAddressInput>;
  /** Business number of the trust */
  businessNumber?: InputMaybe<Scalars['String']['input']>;
  /** FATCA/CRS details for the trust */
  fatcaCrsDetails?: InputMaybe<FatcaCrsDetailsInput>;
  /** RWT rate on interest */
  interestResidentWithholdingTax?: InputMaybe<ResidentWithholdingTaxRateBasisPoints>;
  /** Manual registered address of the company */
  manualRegisteredAddress?: InputMaybe<ManualAddressInput>;
  /** nature and purpose details for the trust */
  natureAndPurpose?: InputMaybe<CreateNatureAndPurposeInput>;
  /** NZ PIR */
  nzPrescribedInvestorRate?: InputMaybe<NzPrescribedInvestorRateBasisPoints>;
  /** Entity-service exemption reason for the primary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  primaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Primary tax identification number for the investing entity. */
  primaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a primary tax resident. */
  primaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** registration number of the trust (if applicable) */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Entity-service exemption reason for the secondary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  secondaryTaxExemptReason?: InputMaybe<Scalars['String']['input']>;
  /** Secondary tax identification number for the investing entity. */
  secondaryTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a secondary tax resident. */
  secondaryTaxResidencyCountryId?: InputMaybe<Scalars['ID']['input']>;
  /** trust documents */
  trustDocuments: Array<Scalars['Upload']['input']>;
  /** name of the trust */
  trustName: Scalars['String']['input'];
  /** trust type */
  trustType: InvestingEntityTrustType;
};

/** CRS (Common Reporting Standard) classification for entities. */
export enum CrsClassification {
  ActiveNfe = 'ACTIVE_NFE',
  CentralBank = 'CENTRAL_BANK',
  GovernmentEntity = 'GOVERNMENT_ENTITY',
  InternationalOrganisation = 'INTERNATIONAL_ORGANISATION',
  Other = 'OTHER',
  PassiveNfe = 'PASSIVE_NFE',
  PubliclyTradedCorp = 'PUBLICLY_TRADED_CORP',
  RelatedEntityOfPubliclyTraded = 'RELATED_ENTITY_OF_PUBLICLY_TRADED'
}

/** Represents a currency object. */
export type Currency = {
  __typename: 'Currency';
  abbreviation: Scalars['String']['output'];
  decimalSeparator: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  symbol: Scalars['String']['output'];
  thousandsSeparator: Scalars['String']['output'];
};

/** Union of all possible custom field types */
export type CustomField = CustomFieldCheckboxes | CustomFieldContent | CustomFieldDocumentUpload | CustomFieldMultiSelect | CustomFieldRadios | CustomFieldSelect | CustomFieldText;

/** Base interface for all custom field types */
export type CustomFieldBase = {
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
};

/** A checkbox field allowing multiple selections from multiple options */
export type CustomFieldCheckboxes = CustomFieldBase & CustomFieldInputBase & {
  __typename: 'CustomFieldCheckboxes';
  /** Optional description providing additional context or instructions */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Available options for selection */
  options: Array<CustomFieldOption>;
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
  /** Whether at least one option must be selected before submission */
  required: Scalars['Boolean']['output'];
  /** An investor's response to this custom field */
  responses?: Maybe<Array<CustomFieldResponse>>;
};

/** A read-only markdown/HTML field for displaying formatted content, instructions, or disclaimers */
export type CustomFieldContent = CustomFieldBase & {
  __typename: 'CustomFieldContent';
  /** HTML content to display */
  content: Scalars['String']['output'];
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
};

/** A document upload field whose answer values contain investing entity document IDs */
export type CustomFieldDocumentUpload = CustomFieldBase & CustomFieldInputBase & {
  __typename: 'CustomFieldDocumentUpload';
  /** Help text displayed below the label */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Display order within the section */
  order: Scalars['Int']['output'];
  /** Whether a document must be supplied */
  required: Scalars['Boolean']['output'];
  /** Stored answer references; values are document IDs, not filenames or URLs */
  responses?: Maybe<Array<CustomFieldResponse>>;
};

/** Input for submitting a single response to a custom field */
export type CustomFieldInput = {
  /** ID of the custom field being responded to */
  id: Scalars['ID']['input'];
  /** The user's response to the field */
  value: Scalars['String']['input'];
};

/** Base interface for custom fields that accept user input */
export type CustomFieldInputBase = {
  /** Optional description providing additional context or instructions */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
  /** Whether the field must be completed before submission */
  required: Scalars['Boolean']['output'];
};

/** A dropdown select field allowing one or more selection from multiple options */
export type CustomFieldMultiSelect = CustomFieldBase & CustomFieldInputBase & {
  __typename: 'CustomFieldMultiSelect';
  /** Optional description providing additional context or instructions */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Available options for selection */
  options: Array<CustomFieldOption>;
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
  /** Whether the field must be completed before submission */
  required: Scalars['Boolean']['output'];
  /** An investor's responses to this custom field */
  responses?: Maybe<Array<CustomFieldResponse>>;
};

/** An option for select, radio, or checkbox fields */
export type CustomFieldOption = {
  __typename: 'CustomFieldOption';
  /** Display label shown to the user */
  label: Scalars['String']['output'];
  /** Value stored when this option is selected. */
  value: Scalars['String']['output'];
};

/** A radio button field allowing one selection from multiple options */
export type CustomFieldRadios = CustomFieldBase & CustomFieldInputBase & {
  __typename: 'CustomFieldRadios';
  /** Optional description providing additional context or instructions */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Available options for selection */
  options: Array<CustomFieldOption>;
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
  /** Whether the field must be completed before submission */
  required: Scalars['Boolean']['output'];
  /** An investor's response to this custom field */
  response?: Maybe<CustomFieldResponse>;
};

/** An investor's response to a single custom field */
export type CustomFieldResponse = {
  __typename: 'CustomFieldResponse';
  /** Unique identifier for the response */
  id: Scalars['ID']['output'];
  /** Label of the custom field at the time of response */
  label: Scalars['String']['output'];
  /** The value provided by the user */
  value: Scalars['String']['output'];
};

/** A section grouping related custom fields together */
export type CustomFieldSection = {
  __typename: 'CustomFieldSection';
  /** Optional description of the section's purpose */
  description?: Maybe<Scalars['String']['output']>;
  /** User-facing display name for the section */
  displayName: Scalars['String']['output'];
  /** Custom fields within this section */
  fields: Array<CustomField>;
  /** Unique identifier for the section */
  id: Scalars['ID']['output'];
  /** Internal name/identifier for the section */
  name: Scalars['String']['output'];
  /** Display order among sections (lower numbers appear first) */
  order: Scalars['Int']['output'];
};

export type CustomFieldSectionInput = {
  /**
   * Responses to the fields within this section.
   *
   * Important, for multiple choice fields, you should submit a separate
   * response for each selected option. This means that for checkbox or multi-select
   * dropdown fields, multiple `CustomFieldInput` objects with the same `id` but
   * different `value`s should be included.
   */
  fields: Array<CustomFieldInput>;
  /** ID of the custom field section */
  id: Scalars['ID']['input'];
};

/** Investor classification a capital-raise custom-field section targets. */
export enum CustomFieldSectionInvestorType {
  Both = 'BOTH',
  Retail = 'RETAIL',
  Wholesale = 'WHOLESALE'
}

/** A dropdown select field allowing one or more selection from multiple options */
export type CustomFieldSelect = CustomFieldBase & CustomFieldInputBase & {
  __typename: 'CustomFieldSelect';
  /** Optional description providing additional context or instructions */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Available options for selection */
  options: Array<CustomFieldOption>;
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
  /** Whether the field must be completed before submission */
  required: Scalars['Boolean']['output'];
  /** An investor's response to this custom field */
  response?: Maybe<CustomFieldResponse>;
};

/** A text input field for free-form text entry */
export type CustomFieldText = CustomFieldBase & CustomFieldInputBase & {
  __typename: 'CustomFieldText';
  /** Optional description providing additional context or instructions */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the field */
  id: Scalars['ID']['output'];
  /** Label displayed to the user */
  label: Scalars['String']['output'];
  /** Display order within the section (lower numbers appear first) */
  order: Scalars['Int']['output'];
  /** Placeholder text shown in the input field */
  placeholder?: Maybe<Scalars['String']['output']>;
  /** Whether the field must be completed before submission */
  required: Scalars['Boolean']['output'];
  /** An investor's response to this custom field */
  response?: Maybe<CustomFieldResponse>;
};

/** Date represented by day, month & year */
export type DayMonthYear = {
  __typename: 'DayMonthYear';
  day: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  year: Scalars['Int']['output'];
};

/** Date represented by day, month & year */
export type DayMonthYearInput = {
  day: Scalars['Int']['input'];
  month: Scalars['Int']['input'];
  year: Scalars['Int']['input'];
};

/** Applicant's self-declared investor classification. */
export enum DeclaredInvestorType {
  /** Retail investor — entitled to full retail-client disclosure and protections. */
  Retail = 'RETAIL',
  /** Wholesale investor — meets the wholesale-client criteria; reduced disclosure applies. */
  Wholesale = 'WHOLESALE'
}

/** Deemed compliant FFI subcategory for FATCA. */
export enum DeemedCompliantSubcategory {
  CertifiedDeemedCompliantFfi = 'CERTIFIED_DEEMED_COMPLIANT_FFI',
  /** Includes Owner-Documented FFI, Non-Registering Local Bank */
  Other = 'OTHER',
  RegisteredDeemedCompliantFfi = 'REGISTERED_DEEMED_COMPLIANT_FFI',
  SponsoredInvestmentVehicle = 'SPONSORED_INVESTMENT_VEHICLE',
  TrusteeDocumentedTrust = 'TRUSTEE_DOCUMENTED_TRUST'
}

/** Deprecated: We don't support deposits on the IP Transactions tab */
export type DepositTransaction = Transaction & {
  __typename: 'DepositTransaction';
  amount: Money;
  /** @deprecated to be removed */
  from?: Maybe<MaybeVerifiableBankAccount>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** Tags applied to the transaction (null for this deprecated type) */
  tags?: Maybe<Array<TransactionTag>>;
  /** @deprecated to be removed */
  to?: Maybe<MoneyAccount>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

export type DestroySessionInput = {
  token: Scalars['JWT']['input'];
};

/** Removes the enrolment and retires every backup code with it. */
export type DisableAuthenticatorInput = {
  /** The account's current password, re-proved before the factor is removed. */
  password: Scalars['String']['input'];
};

/** Deprecated: Distribution payment transactions are not returned from the new indexed transaction search */
export type DistributionPaymentTransaction = Transaction & {
  __typename: 'DistributionPaymentTransaction';
  amount: Money;
  from?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** Tags applied to the transaction (null for this deprecated type) */
  tags?: Maybe<Array<TransactionTag>>;
  /** @deprecated to be removed */
  to?: Maybe<MoneyAccount>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

/** A distribution transaction for search results */
export type DistributionSearchTransaction = {
  __typename: 'DistributionSearchTransaction';
  /** Transaction amount */
  amount: Money;
  /** Status of the transaction */
  distributionTransactionStatus?: Maybe<DistributionTransactionItemStatus>;
  /** Fees withheld from this distribution. */
  feesWithheld?: Maybe<HighPrecisionMoney>;
  /** Fund associated with the transaction */
  fund?: Maybe<Fund>;
  /** Gross distribution amount */
  grossDistribution?: Maybe<Money>;
  /** Unique identifier for the transaction */
  id: Scalars['ID']['output'];
  /** Investing entity associated with the transaction */
  investingEntity?: Maybe<InvestingEntity>;
  /** Net distribution amount after deductions */
  netDistribution?: Maybe<Money>;
  /** Date the transaction was processed. Null if pending. */
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Tax withheld amount */
  taxWithheld?: Maybe<Money>;
  /** Unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

/** Edge in the distribution transaction search results */
export type DistributionSearchTransactionEdge = {
  __typename: 'DistributionSearchTransactionEdge';
  /** Cursor for pagination */
  cursor: Scalars['String']['output'];
  /** The distribution transaction */
  node: DistributionSearchTransaction;
};

/** Paginated results for distribution transaction searches */
export type DistributionSearchTransactionResults = {
  __typename: 'DistributionSearchTransactionResults';
  /** List of distribution transaction edges */
  edges: Array<DistributionSearchTransactionEdge>;
  /** Pagination information */
  pageInfo: PageInfo;
};

/** Deprecated: Distribution transactions are not returned from the new indexed transaction search */
export type DistributionTransaction = Transaction & {
  __typename: 'DistributionTransaction';
  amount: Money;
  exchangeRate?: Maybe<Money>;
  exchangedAt?: Maybe<Scalars['DateTime']['output']>;
  from?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  preExchangeAmount?: Maybe<Money>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: DistributionTransactionStatus;
  /** Tags applied to the transaction (null for this deprecated type) */
  tags?: Maybe<Array<TransactionTag>>;
  /** @deprecated to be removed */
  to?: Maybe<MoneyAccount>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

export enum DistributionTransactionItemStatus {
  Imported = 'IMPORTED',
  Paid = 'PAID',
  Pending = 'PENDING',
  Reinvested = 'REINVESTED',
  Withheld = 'WITHHELD'
}

/** Sort options for distribution transaction search */
export type DistributionTransactionSearchSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Field to sort by */
  field: DistributionTransactionSearchSortField;
};

/** Enum for distribution transaction search sort fields */
export enum DistributionTransactionSearchSortField {
  /** Sort by fund */
  Fund = 'FUND',
  /** Sort by gross amount */
  GrossAmount = 'GROSS_AMOUNT',
  /** Sort by id */
  Id = 'ID',
  /** Sort by investing entity */
  InvestingEntity = 'INVESTING_ENTITY',
  /** Sort by net amount */
  NetAmount = 'NET_AMOUNT',
  /** Sort by payment date */
  PaymentDate = 'PAYMENT_DATE',
  /** Sort by status */
  Status = 'STATUS',
  /** Sort by tax withheld */
  TaxWithheld = 'TAX_WITHHELD',
  /** Sort by unit class */
  UnitClass = 'UNIT_CLASS'
}

export enum DistributionTransactionStatus {
  Complete = 'COMPLETE',
  Pending = 'PENDING',
  Withheld = 'WITHHELD'
}

export type Document = {
  __typename: 'Document';
  category: DocumentCategory;
  file: RemoteAsset;
  fund?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /**
   * The in-scope investing entities this document is attached to. Populated by the
   * cross-entity `Account.searchDocuments` query; empty for the single-entity search.
   */
  investingEntities: Array<InvestingEntity>;
  published: Scalars['DateTime']['output'];
  title: Scalars['String']['output'];
  /** unit class associated with the document */
  unitClass?: Maybe<UnitClass>;
  /**
   * When this document was last marked as viewed for the authenticated account, or null if it is unmarked.
   * Per account, not per investing entity.
   */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
};

export enum DocumentCategory {
  Authority = 'AUTHORITY',
  ChangeOfDetails = 'CHANGE_OF_DETAILS',
  CorporateActions = 'CORPORATE_ACTIONS',
  DistributionStatements = 'DISTRIBUTION_STATEMENTS',
  FinancialReports = 'FINANCIAL_REPORTS',
  FundUpdates = 'FUND_UPDATES',
  HoldingMovements = 'HOLDING_MOVEMENTS',
  HoldingStatements = 'HOLDING_STATEMENTS',
  OfferDocuments = 'OFFER_DOCUMENTS',
  Other = 'OTHER',
  PerformanceReports = 'PERFORMANCE_REPORTS',
  Risk = 'RISK',
  SourceOfFunds = 'SOURCE_OF_FUNDS',
  SourceOfWealth = 'SOURCE_OF_WEALTH',
  SubscriptionDocuments = 'SUBSCRIPTION_DOCUMENTS',
  TaxResidency = 'TAX_RESIDENCY',
  TaxStatements = 'TAX_STATEMENTS'
}

export type DocumentSearchFilters = {
  category?: InputMaybe<DocumentCategory>;
  fundId?: InputMaybe<Scalars['ID']['input']>;
  holdingId?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict to documents the authenticated account has (true) or has not (false) viewed. */
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Filters for the cross-entity `Account.searchDocuments` query. All optional;
 * omitting `investingEntityIds` searches every entitled entity. `fundIds`,
 * `unitClassIds` and `holdingIds` are independent filters — a document must match
 * one of the funds AND one of the unit classes AND one of the holdings when they
 * are supplied.
 */
export type DocumentSearchFiltersV2 = {
  categories?: InputMaybe<Array<DocumentCategory>>;
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  holdingIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict to documents the authenticated account has (true) or has not (false) viewed. */
  viewed?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DocumentSearchResult = {
  __typename: 'DocumentSearchResult';
  cursor: Scalars['String']['output'];
  node: Document;
};

export type DocumentSearchResults = {
  __typename: 'DocumentSearchResults';
  edges: Array<DocumentSearchResult>;
  pageInfo: PageInfo;
};

export type DocumentSearchSort = {
  direction: SortDirection;
  field: DocumentSearchSortField;
};

export enum DocumentSearchSortField {
  Category = 'CATEGORY',
  Fund = 'FUND',
  Published = 'PUBLISHED',
  Title = 'TITLE',
  UnitClass = 'UNIT_CLASS'
}

export type DocumentToDownload = {
  /** @deprecated Ignored. Each entry takes the document's download name. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  documentId: Scalars['ID']['input'];
};

export type EurVerifiableBankAccount = VerifiableBankAccount & {
  __typename: 'EURVerifiableBankAccount';
  accountNumber: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  status: BankAccountStatus;
};

/** Types of IE-targeted email an associated account can be subscribed to per investing entity. */
export enum EmailCategory {
  /** Distribution notifications */
  Distributions = 'DISTRIBUTIONS',
  /** Holding and tax statements */
  HoldingAndTaxStatements = 'HOLDING_AND_TAX_STATEMENTS',
  /** Order confirmations and holding movement notifications */
  OrdersAndHoldingMovements = 'ORDERS_AND_HOLDING_MOVEMENTS',
  /** Fund updates and reports */
  UpdatesAndReports = 'UPDATES_AND_REPORTS'
}

/** Describes the email preferences of a user. */
export type EmailPreferences = {
  __typename: 'EmailPreferences';
  accountActivity: Scalars['Boolean']['output'];
  investmentOpportunities: Scalars['Boolean']['output'];
};

export type Entity = CompanyInvestingEntity | IndividualInvestingEntity | JointIndividualInvestingEntity | PartnershipInvestingEntity | TrustInvestingEntity;

export type EntityTaxDetails = {
  __typename: 'EntityTaxDetails';
  /** RWT rate on interest */
  interestResidentWithholdingTax?: Maybe<ResidentWithholdingTaxRateBasisPoints>;
  /** NZ PIR */
  nzPrescribedInvestorRate?: Maybe<NzPrescribedInvestorRateBasisPoints>;
  /** Canonical entity-service exemption reason for the primary residency, when no real tax identifier is provided. */
  primaryTaxExemptReason?: Maybe<Scalars['String']['output']>;
  /** Primary tax identification number for the investing entity. */
  primaryTaxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  /** Country where the investing entity is a primary tax resident. */
  primaryTaxResidencyCountry?: Maybe<Country>;
  /** Canonical entity-service exemption reason for the secondary residency, when no real tax identifier is provided. */
  secondaryTaxExemptReason?: Maybe<Scalars['String']['output']>;
  /** Secondary tax identification number for the investing entity. */
  secondaryTaxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  /** Country where the investing entity is a secondary tax resident. */
  secondaryTaxResidencyCountry?: Maybe<Country>;
};

/** FATCA classification for entities. Applies to Company, Trust, Partnership entity types. */
export enum FatcaClassification {
  ActiveNffe = 'ACTIVE_NFFE',
  DeemedCompliantFfi = 'DEEMED_COMPLIANT_FFI',
  DirectReportingNffe = 'DIRECT_REPORTING_NFFE',
  ExemptBeneficialOwner = 'EXEMPT_BENEFICIAL_OWNER',
  NonParticipatingFfi = 'NON_PARTICIPATING_FFI',
  Other = 'OTHER',
  OwnerDocumentedFfi = 'OWNER_DOCUMENTED_FFI',
  ParticipatingFfi = 'PARTICIPATING_FFI',
  PassiveNffe = 'PASSIVE_NFFE',
  SponsoredDirectReportingNffe = 'SPONSORED_DIRECT_REPORTING_NFFE',
  UsSpecifiedPerson = 'US_SPECIFIED_PERSON'
}

/**
 * Consolidated FATCA/CRS details for all entity types.
 * Entity-specific fields: countryOfIncorporation, usTinEin, fatcaClassification, giin, sponsorGiin, deemedCompliantSubcategory, isFinancialInstitution, fiReportingType, isManagedByFi, crsClassification
 * Common fields: isUsPerson, usTaxIdentificationNumber, fatcaCrsDeclaration
 */
export type FatcaCrsDetails = {
  __typename: 'FatcaCrsDetails';
  /** Country of incorporation/establishment. Company/Trust/Partnership only. */
  countryOfIncorporation?: Maybe<Country>;
  /** CRS classification. Company/Trust/Partnership only. */
  crsClassification?: Maybe<CrsClassification>;
  /** Free-text CRS classification description when classification is OTHER */
  crsClassificationOther?: Maybe<Scalars['String']['output']>;
  /** Deemed compliant FFI subcategory. Company/Trust/Partnership only. */
  deemedCompliantSubcategory?: Maybe<DeemedCompliantSubcategory>;
  /** FATCA classification. Company/Trust/Partnership only. */
  fatcaClassification?: Maybe<FatcaClassification>;
  /** Whether the entity has made a FATCA/CRS declaration */
  fatcaCrsDeclaration?: Maybe<Scalars['Boolean']['output']>;
  /** When the FATCA/CRS declaration was made. Set once by the server on first declaration and never changed. Null if the declaration has never been made. */
  fatcaCrsDeclarationAt?: Maybe<Scalars['DateTime']['output']>;
  /** Financial Institution reporting type. Company/Trust/Partnership only. */
  fiReportingType?: Maybe<FiReportingType>;
  /** Global Intermediary Identification Number (GIIN). Company/Trust/Partnership only. */
  giin?: Maybe<Scalars['String']['output']>;
  /** The ID of the FATCA/CRS record */
  id: Scalars['ID']['output'];
  /** Whether entity is a Financial Institution. Company/Trust/Partnership only. */
  isFinancialInstitution?: Maybe<Scalars['Boolean']['output']>;
  /** Whether FI is managed by another FI. Company/Trust/Partnership only. */
  isManagedByFi?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this entity is a US person for tax purposes. */
  isUsPerson?: Maybe<Scalars['Boolean']['output']>;
  /** Sponsor's GIIN for sponsored entities. Company/Trust/Partnership only. */
  sponsorGiin?: Maybe<Scalars['String']['output']>;
  /** US tax identification number if the entity is a US person */
  usTaxIdentificationNumber?: Maybe<Scalars['String']['output']>;
  /** US TIN/EIN for entity types. Company/Trust/Partnership only. */
  usTinEin?: Maybe<Scalars['String']['output']>;
};

/**
 * FATCA/CRS details input for creating or updating entities.
 * All fields are optional. Common fields (all entity types): isUsPerson, usTaxIdentificationNumber, fatcaCrsDeclaration.
 * Entity-specific (Company/Trust/Partnership): countryOfIncorporationId, usTinEin, fatcaClassification, giin, sponsorGiin, deemedCompliantSubcategory, isFinancialInstitution, fiReportingType, isManagedByFi, crsClassification.
 * For individual-specific fields like dateOfBirth, use UpdateFatcaCRSInput.
 */
export type FatcaCrsDetailsInput = {
  /** ISO 3166-1 numeric-3 for country of incorporation/establishment (Company/Trust/Partnership only) */
  countryOfIncorporationId?: InputMaybe<Scalars['ID']['input']>;
  /** CRS classification (Company/Trust/Partnership only) */
  crsClassification?: InputMaybe<CrsClassification>;
  /** Free-text CRS classification description when classification is OTHER */
  crsClassificationOther?: InputMaybe<Scalars['String']['input']>;
  /** Deemed compliant FFI subcategory (Company/Trust/Partnership only) */
  deemedCompliantSubcategory?: InputMaybe<DeemedCompliantSubcategory>;
  /** FATCA classification (Company/Trust/Partnership only) */
  fatcaClassification?: InputMaybe<FatcaClassification>;
  /** Whether the entity has made a FATCA/CRS declaration */
  fatcaCrsDeclaration?: InputMaybe<Scalars['Boolean']['input']>;
  /** Financial Institution reporting type (Company/Trust/Partnership only) */
  fiReportingType?: InputMaybe<FiReportingType>;
  /** Global Intermediary Identification Number (Company/Trust/Partnership only) */
  giin?: InputMaybe<Scalars['String']['input']>;
  /** Whether entity is a Financial Institution (Company/Trust/Partnership only) */
  isFinancialInstitution?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether FI is managed by another FI (Company/Trust/Partnership only) */
  isManagedByFi?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether this entity is a US person for tax purposes */
  isUsPerson?: InputMaybe<Scalars['Boolean']['input']>;
  /** Sponsor's GIIN for sponsored entities (Company/Trust/Partnership only) */
  sponsorGiin?: InputMaybe<Scalars['String']['input']>;
  /** US tax identification number if the entity is a US person */
  usTaxIdentificationNumber?: InputMaybe<Scalars['String']['input']>;
  /** US TIN/EIN (Company/Trust/Partnership only) */
  usTinEin?: InputMaybe<Scalars['String']['input']>;
};

export type FeatureFlag = {
  __typename: 'FeatureFlag';
  isEnabled: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

/** Financial Institution reporting type for FATCA/CRS. */
export enum FiReportingType {
  NonReporting = 'NON_REPORTING',
  Reporting = 'REPORTING'
}

export type FixedPointNumber = {
  __typename: 'FixedPointNumber';
  /** Number of decimal places */
  decimalPlaces: Scalars['Int']['output'];
  /** Value of the fixed point number */
  value: Scalars['String']['output'];
};

export type FixedPointNumberInput = {
  /** Unit precision scale from the fund */
  decimalPlaces: Scalars['Int']['input'];
  /** Value of the fixed point number */
  value: Scalars['String']['input'];
};

/** Represents a fraction. Used to avoid floating point issues */
export type Fraction = {
  __typename: 'Fraction';
  denominator: Scalars['Int']['output'];
  numerator: Scalars['Int']['output'];
};

export type Fund = {
  __typename: 'Fund';
  asset?: Maybe<Asset>;
  /** Asset structure of the Fund scheme */
  assetStructure: AssetStructure;
  assets: Array<Asset>;
  cardImageUrl: Scalars['String']['output'];
  currency: Currency;
  /** Custom metrics for the fund configured by the fund manager */
  customKeyMetrics: Array<FundCustomKeyMetric>;
  /** The fund has been exited if exitDetails is non-null */
  exitDetails?: Maybe<FundExitDetails>;
  heroImageUrl: Scalars['String']['output'];
  /** Configuration for the holding page */
  holdingPage: HoldingPageConfiguration;
  id: Scalars['ID']['output'];
  /** @deprecated no longer supported */
  isMarketplaceFund?: Maybe<Scalars['Boolean']['output']>;
  /** The displayed country where the Fund is based */
  location: Scalars['String']['output'];
  /** The displayed title of the Fund */
  name: Scalars['String']['output'];
  openDate?: Maybe<Scalars['DateTime']['output']>;
  /** The secondary market for the fund, if there is one */
  secondaryMarket?: Maybe<SecondaryMarket>;
  /** The displayed slug of the Fund */
  slug: Scalars['String']['output'];
  /** Summary of the fund, with visibility configured by the fund manager */
  summary: FundSummary;
  thumbnailImageUrl: Scalars['String']['output'];
  /** unit precision scale for the fund - maximum 9dp */
  unitPrecisionScale: Scalars['Int']['output'];
  unitRedemptions?: Maybe<FundUnitRedemptionConfiguration>;
};


export type FundAssetArgs = {
  slug: Scalars['String']['input'];
};

export type FundCustomKeyMetric = {
  __typename: 'FundCustomKeyMetric';
  /** The name of the custom metric */
  name: Scalars['String']['output'];
  /** The value of the custom metric */
  value: Scalars['String']['output'];
};

export type FundExitDetails = {
  __typename: 'FundExitDetails';
  overviewMetrics: Array<FundMetric>;
};

/** Deprecated: Fund exit transactions are not returned from the new indexed transaction search */
export type FundExitTransaction = Transaction & {
  __typename: 'FundExitTransaction';
  amount: Money;
  from?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** Tags applied to the transaction (null for this deprecated type) */
  tags?: Maybe<Array<TransactionTag>>;
  /** @deprecated to be removed */
  to?: Maybe<MoneyAccount>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

/** Possible key metric types to be displayed for an investor's holding. */
export enum FundHoldingKeyMetricType {
  CapitalBalance = 'CAPITAL_BALANCE',
  CapitalCommitted = 'CAPITAL_COMMITTED',
  CapitalContributed = 'CAPITAL_CONTRIBUTED',
  CapitalDistributed = 'CAPITAL_DISTRIBUTED',
  CapitalGain = 'CAPITAL_GAIN',
  CapitalReturned = 'CAPITAL_RETURNED',
  CashYield = 'CASH_YIELD',
  EquityMultiple = 'EQUITY_MULTIPLE',
  HoldingValue = 'HOLDING_VALUE',
  IncomeDistributed = 'INCOME_DISTRIBUTED',
  InternalRateOfReturn = 'INTERNAL_RATE_OF_RETURN',
  InvestedSince = 'INVESTED_SINCE',
  LastDistributionDate = 'LAST_DISTRIBUTION_DATE',
  UnitCount = 'UNIT_COUNT',
  UnitPrice = 'UNIT_PRICE'
}

export type FundMetric = {
  __typename: 'FundMetric';
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** Summary of a fund, with visibility configured by the fund manager */
export type FundSummary = {
  __typename: 'FundSummary';
  /** Description of the fund */
  content: Scalars['String']['output'];
  /** Show the fund summary on an investor's holding */
  showOnHolding: Scalars['Boolean']['output'];
  /** Show the fund summary on secondary market listings */
  showOnSecondaryMarketListing: Scalars['Boolean']['output'];
};

export type FundUnitRedemptionConfiguration = {
  __typename: 'FundUnitRedemptionConfiguration';
  /** Whether redemptions are enabled for the fund */
  enabled: Scalars['Boolean']['output'];
};

export type GbpBankAccountBankAccountLocationDetails = {
  __typename: 'GBPBankAccountBankAccountLocationDetails';
  /** Sort code for UK bank accounts */
  sortCode: Scalars['String']['output'];
};

export type GbpBankAccountInput = {
  sortCode: Scalars['String']['input'];
};

export type GbpVerifiableBankAccount = VerifiableBankAccount & {
  __typename: 'GBPVerifiableBankAccount';
  accountNumber: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  sortCode: Scalars['String']['output'];
  status: BankAccountStatus;
};

export type GenerateDistributionsCsvInput = {
  /** Filter distributions on or after this date */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter distributions on or before this date */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Export only these distribution payments. Omitting the field or providing an empty list exports all matching payments. */
  distributionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by fund IDs */
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Filter by investing entity IDs. Provide an explicit empty list to export across all of the account's investing entities; omit the field to export only the active investing entity. */
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by keywords */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Sort options */
  sort?: InputMaybe<DistributionTransactionSearchSort>;
  /** Filter by distribution transaction statuses */
  statuses?: InputMaybe<Array<DistributionTransactionItemStatus>>;
  /** Filter by unit class IDs */
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type GenerateTransactionsCsvInput = {
  /** Filter transactions on or after this date */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter transactions on or before this date */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated Use fundIds instead */
  fundID?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by fund IDs */
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Not supported in the new indexed transaction search */
  holdingID?: InputMaybe<Scalars['ID']['input']>;
  /** Filter by investing entity IDs. Provide an explicit empty list to export across all of the account's investing entities; omit the field to export only the active investing entity. */
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Search by keywords */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Filter by transaction types */
  searchTransactionTypes?: InputMaybe<Array<SearchTransactionType>>;
  /** Sort options */
  sort?: InputMaybe<TransactionSearchSort>;
  /** Filter by tags (e.g. only Principal) */
  tags?: InputMaybe<Array<TransactionTag>>;
  /** Export only these transactions. Omitting the field or providing an empty list exports all matching transactions. */
  transactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** @deprecated Use searchTransactionTypes instead */
  transactionTypes?: InputMaybe<Array<TransactionType>>;
  /** Filter by unit class IDs */
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type HelloSignDocument = {
  __typename: 'HelloSignDocument';
  helloSignId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  signatures: Array<Maybe<HelloSignSignature>>;
  template?: Maybe<HelloSignDocumentTemplate>;
  viewURL: Scalars['String']['output'];
};

export enum HelloSignDocumentTemplate {
  EligibleInvestorCertificate = 'ELIGIBLE_INVESTOR_CERTIFICATE',
  ProfessionalInvestorCertificate = 'PROFESSIONAL_INVESTOR_CERTIFICATE',
  SafeHarbourCertificate = 'SAFE_HARBOUR_CERTIFICATE',
  SophisticatedInvestorCertificate = 'SOPHISTICATED_INVESTOR_CERTIFICATE'
}

export type HelloSignSignature = {
  __typename: 'HelloSignSignature';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  isMe: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  relationship: HelloSignSignatureRelationship;
  signingURL: Scalars['String']['output'];
  status: HelloSignSignatureStatus;
};

export enum HelloSignSignatureRelationship {
  Adviser = 'ADVISER',
  Investor = 'INVESTOR'
}

export enum HelloSignSignatureStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

/** Represents an amount in monetary value in greater precision. */
export type HighPrecisionMoney = {
  __typename: 'HighPrecisionMoney';
  amount: Scalars['MoneyUnit']['output'];
  currency: Currency;
};

/** High-precision monetary input value. Mirrors the `HighPrecisionMoney` output type. */
export type HighPrecisionMoneyInput = {
  amount: Scalars['MoneyUnit']['input'];
  currencyId: Scalars['ID']['input'];
};

export type Holding = {
  __typename: 'Holding';
  /**
   * The single eligible open capital raise for this holding's unit class, or null
   * when the "Add to Investment" affordance should be hidden. Eligible = open,
   * digital applications enabled, not archived, access rules pass for the viewer,
   * and exactly one such raise exists for the class. Resolved server-side.
   */
  addToInvestmentOffer?: Maybe<Offer>;
  bankAccount?: Maybe<AudVerifiableBankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount | VerifiableBankAccountImpl>;
  /** The remaining capital in the holding. */
  capitalBalance: Money;
  /** The total amount of capital committed to the holding. */
  capitalCommitted: Money;
  /** The total amount of capital deployed to acquire units in the holding. */
  capitalContributed: Money;
  /** The total amount of capital paid out to investors via distributions flagged as capital (return of capital, capital gains, etc.), net of withholding. Excludes redemptions, secondary-market sales, and transfers out of the holding (see capitalReturned). */
  capitalDistributed: Money;
  /** The total capital gain/loss for the holding. */
  capitalGain: Money;
  /** The total amount of capital returned to investors via redemptions, secondary-market sales, transfers out, and other unit-reducing transactions on the holding. */
  capitalReturned: Money;
  /** The annual % return generated by the holding from income (cash) distributions. */
  cashYield?: Maybe<Fraction>;
  /** The date that the holding was created - when the first units were issued to the investor. */
  createdAt: Scalars['DateTime']['output'];
  distributionReinvestmentEnabled?: Maybe<Scalars['Boolean']['output']>;
  distributionSettings?: Maybe<HoldingDistributionSettings>;
  /** The total return multiple on capital invested in the holding. */
  equityMultiple?: Maybe<Scalars['Float']['output']>;
  fund: Fund;
  id: Scalars['ID']['output'];
  /** The total amount of income returned to investors from the holding. */
  incomeDistributed: Money;
  /** The annual rate of return of the holding considering the size and timing of cash flows. */
  internalRateOfReturn?: Maybe<Fraction>;
  /** The date of the most recent distribution for the holding. */
  lastDistributedAt?: Maybe<Scalars['DateTime']['output']>;
  liquidationReason?: Maybe<LiquidationReason>;
  /**
   * The sell order just created by placeSellOrder, as a unified cross-entity Order
   * sourced from the write itself (primary, consistent). Populated only on the
   * Holding returned from placeSellOrder; null when a Holding is returned from any
   * other field.
   */
  order?: Maybe<Order>;
  slug: Scalars['ID']['output'];
  /**
   * Plot points for 'Holding Total Distributed'.
   * Refer to Caruso - Calculations for documentation. https://docs.google.com/document/d/1xIQBnp_f1e3am01uzA2O6HJNksIrcj3Jtylrju43NMs
   */
  totalDistributedPoints?: Maybe<Array<MoneySeriesPoint>>;
  /** The total value of the holding based on the Fund unit price and number of units in the holding */
  totalValue: Money;
  /**
   * Plot points for 'Holding Holding Value'.
   * Refer to Caruso - Calculations for documentation. https://docs.google.com/document/d/1xIQBnp_f1e3am01uzA2O6HJNksIrcj3Jtylrju43NMs
   */
  totalValuePoints?: Maybe<Array<MoneySeriesPoint>>;
  unitClass: UnitClass;
  unitCountDecimal: FixedPointNumber;
};


export type HoldingTotalDistributedPointsArgs = {
  periodEndExclusive: Scalars['DateTime']['input'];
  periodStartInclusive?: InputMaybe<Scalars['DateTime']['input']>;
  rollup?: InputMaybe<ChartRollup>;
  statistic?: InputMaybe<ChartAggregationStatistic>;
};


export type HoldingTotalValuePointsArgs = {
  periodEndExclusive: Scalars['DateTime']['input'];
  periodStartInclusive?: InputMaybe<Scalars['DateTime']['input']>;
  rollup?: InputMaybe<ChartRollup>;
  statistic?: InputMaybe<ChartAggregationStatistic>;
};

export enum HoldingDistributionSettings {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED',
  Withheld = 'WITHHELD'
}

/** Configuration for the holding page */
export type HoldingPageConfiguration = {
  __typename: 'HoldingPageConfiguration';
  /** Whether the fund manager has configured the fund to show the capital commitments chart on holdings. */
  isCapitalCommitmentsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured the fund to show the cumulative distributions chart on holdings. */
  isCumulativeDistributionsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured the fund to show the recent distributions chart on holdings. */
  isRecentDistributionsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured to show a page for holdings in this fund. */
  isShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured the fund to show the total value chart on holdings. */
  isTotalValueChartShown: Scalars['Boolean']['output'];
  /**
   * List of key metric types to be displayed, with visibility configured by the fund manager. These should be displayed
   * alongside the fund's `customKeyMetrics`.
   */
  visibleKeyMetrics: Array<FundHoldingKeyMetricType>;
};

/**
 * A holding returned by the account-level holdings search. Carries the indexed projection of the
 * holding - its owning investing entity, lifecycle status, fund, unit class and computed values - and
 * also exposes the full `holding`, resolved on demand for clients that need the heavier rollups.
 */
export type HoldingSearchItem = {
  __typename: 'HoldingSearchItem';
  /** Total capital committed to the holding. */
  capitalCommitted?: Maybe<HighPrecisionMoney>;
  /** Total capital contributed to the holding. */
  capitalContributed?: Maybe<HighPrecisionMoney>;
  /** Total capital returned from the holding, as held in the search index. May lag or differ from Holding.capitalReturned (the live figure). */
  capitalReturned?: Maybe<HighPrecisionMoney>;
  /** Distribution settings for the holding. */
  distributionSettings?: Maybe<HoldingDistributionSettings>;
  /** Fund the holding belongs to. */
  fund?: Maybe<Fund>;
  /** The full holding, resolved on demand for clients that need the heavier rollups. */
  holding: Holding;
  /** Current value of the holding based on the latest unit price. */
  holdingValue?: Maybe<HighPrecisionMoney>;
  /** Unique identifier of the holding. */
  id: Scalars['ID']['output'];
  /** The date the holding was created - when the first units were issued to the investor. */
  inceptionDate?: Maybe<Scalars['DateTime']['output']>;
  /** The investing entity that owns the holding. */
  investingEntity?: Maybe<InvestingEntity>;
  /** Lifecycle status of the holding. */
  status?: Maybe<HoldingStatus>;
  /** Total amount distributed from the holding. */
  totalDistributed?: Maybe<HighPrecisionMoney>;
  /** Unit class the holding is in. */
  unitClass?: Maybe<UnitClass>;
  /** The holding's share of its unit class, as a fraction between 0 and 1. */
  unitClassPercentage?: Maybe<Scalars['Float']['output']>;
  /** Number of units held. */
  units?: Maybe<FixedPointNumber>;
};

/** Edge in the holdings search results. */
export type HoldingSearchItemEdge = {
  __typename: 'HoldingSearchItemEdge';
  /** Cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The holding search item. */
  node: HoldingSearchItem;
};

/** Paginated results for the account-level holdings search. */
export type HoldingSearchResults = {
  __typename: 'HoldingSearchResults';
  /** List of holding search item edges. */
  edges: Array<HoldingSearchItemEdge>;
  /** Pagination information. */
  pageInfo: PageInfo;
};

/** Sort options for holdings search. */
export type HoldingSearchSort = {
  /** Sort direction. */
  direction: SortDirection;
  /** Field to sort by. */
  field: HoldingSearchSortField;
};

/** Fields the holdings search can be sorted by. */
export enum HoldingSearchSortField {
  /** Sort by capital committed. */
  CapitalCommitted = 'CAPITAL_COMMITTED',
  /** Sort by capital contributed. */
  CapitalContributed = 'CAPITAL_CONTRIBUTED',
  /** Sort by capital returned. */
  CapitalReturned = 'CAPITAL_RETURNED',
  /** Sort by date created. */
  DateCreated = 'DATE_CREATED',
  /** Sort by distribution preference. */
  DistributionPreference = 'DISTRIBUTION_PREFERENCE',
  /** Sort by fund. */
  Fund = 'FUND',
  /** Sort by holding value. */
  HoldingValue = 'HOLDING_VALUE',
  /** Sort by id. */
  Id = 'ID',
  /** Sort by investing entity. */
  InvestingEntity = 'INVESTING_ENTITY',
  /** Sort by number of units. */
  NumUnits = 'NUM_UNITS',
  /** Sort by total distributed. */
  TotalDistributed = 'TOTAL_DISTRIBUTED',
  /** Sort by unit class. */
  UnitClass = 'UNIT_CLASS',
  /** Sort by the holding's percentage of its unit class. */
  UnitClassPercentage = 'UNIT_CLASS_PERCENTAGE'
}

/** Lifecycle status of a holding, derived from the holdings search index. */
export enum HoldingStatus {
  /** The holding currently has units. */
  Active = 'ACTIVE',
  /** The holding has never had any effective units (includes newly issued t+1 holdings). */
  Inactive = 'INACTIVE',
  /** The holding previously held units but has since been fully redeemed. */
  Settled = 'SETTLED'
}

/** A key/value pair to provide of identity document information */
export type IdentityDocumentFieldInput = {
  key: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export enum IdentityDocumentType {
  DriverLicence = 'DRIVER_LICENCE',
  Passport = 'PASSPORT'
}

export enum IdentityVerificationType {
  Account = 'ACCOUNT',
  BeneficialOwner = 'BENEFICIAL_OWNER',
  UnauthenticatedAccount = 'UNAUTHENTICATED_ACCOUNT'
}

/** A file that is intended to be displayed in the application as media content. */
export type Image = {
  __typename: 'Image';
  contentType: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** A key-value pair with an index, used to maintain order in lists */
export type IndexedKeyValue = {
  __typename: 'IndexedKeyValue';
  /** Index of the key-value pair in the list, starting from 0 */
  index: Scalars['Int']['output'];
  /** Key of the key-value pair */
  key: Scalars['String']['output'];
  /** Value of the key-value pair */
  value: Scalars['String']['output'];
};

export type IndividualInvestingEntity = {
  __typename: 'IndividualInvestingEntity';
  /** Address */
  address?: Maybe<Address>;
  /** Date of birth of the individual */
  dateOfBirth?: Maybe<DayMonthYear>;
  /** Email address of the individual */
  email?: Maybe<Scalars['String']['output']>;
  /** Get FATCA/CRS details for an investing entity, joint individual, or related party. Provide exactly one target. */
  fatcaCrsDetails?: Maybe<FatcaCrsDetails>;
  /** First name of the individual */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for this individual. For individual two in a joint account, this is the joint_individual_investors ID used as jointIndividualId in UpdateFatcaCRSInput. */
  id: Scalars['ID']['output'];
  /** Last name of the individual */
  lastName?: Maybe<Scalars['String']['output']>;
  /** Middle name of the individual */
  middleName?: Maybe<Scalars['String']['output']>;
  /** Nature and purpose details for the individual */
  natureAndPurposeDetails?: Maybe<NatureAndPurposeDetails>;
  /** Phone number of the individual */
  phoneNumber?: Maybe<PhoneNumber>;
  /** Place of birth of the individual */
  placeOfBirth?: Maybe<PlaceOfBirth>;
  /** Primary citizenship of the individual */
  primaryCitizenshipId?: Maybe<Country>;
  /** Entity tax details */
  taxDetails?: Maybe<EntityTaxDetails>;
};

/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntity = {
  __typename: 'InvestingEntity';
  accreditation?: Maybe<RetailOnlyAccreditation | WholesaleAccreditation>;
  /** Definition of accreditation is based on the country where the investor is investing from. */
  accreditationCountry?: Maybe<Country>;
  /** @deprecated use entity.address */
  address?: Maybe<Scalars['String']['output']>;
  allocationRequest?: Maybe<AllocationRequest>;
  /** Allocation request(s) in new offers made by (or for) this investing entity */
  allocationRequests: Array<AllocationRequest>;
  /** Accounts with access to this investing entity */
  associatedAccounts: Array<AssociatedAccount>;
  bankAccounts: Array<AudVerifiableBankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount | VerifiableBankAccountImpl>;
  /** Whether this investing entity has access to apply against the given offer. */
  canAccessOffer: Scalars['Boolean']['output'];
  /** @deprecated use entity.companyType */
  companyType?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Country>;
  documents: Array<Maybe<RemoteAsset>>;
  entity: Entity;
  entityTypeEnum: InvestingEntityType;
  /** If this Investing Entity is a joint-individual, the joint-individual second investor details */
  frequencyOfInvestment?: Maybe<InvestingEntityFrequencyOfInvestment>;
  /** The number of active holdings on the investing entity */
  holdingCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Holdings on the investing entity, returned as a lightweight `BaseHolding` projection
   * that omits the heavier rollups computed by `Portfolio.holdings`.
   */
  holdings: Array<BaseHolding>;
  id: Scalars['ID']['output'];
  /** Is this investing entity the selected investing entity for the logged in user Todo: make this field required once implemented */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Is the logged in user the key account holder for this investing entity */
  isKeyAccount?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated use entity.name */
  name?: Maybe<Scalars['String']['output']>;
  /** Returns a notification for the given type belong to this investing entity, null if there is no such notification */
  notification?: Maybe<AddBankAccountNotification | ConfirmAccreditationNotification | ConfirmUnsupportedCountryAccreditationNotification | ProvideBeneficialOwnerContactDetailsNotification | ProvideInvestingEntityDocumentsNotification | ProvideSourceOfFundsNotification | ReattemptConfirmAccreditationNotification | ReattemptProvideSourceOfFundsNotification | RenewAccreditationNotification | VerifyBankAccountNotification>;
  /** All notifications for this investing entity, optionaly filtered by status */
  notifications: Array<AddBankAccountNotification | ConfirmAccreditationNotification | ConfirmUnsupportedCountryAccreditationNotification | ProvideBeneficialOwnerContactDetailsNotification | ProvideInvestingEntityDocumentsNotification | ProvideSourceOfFundsNotification | ReattemptConfirmAccreditationNotification | ReattemptProvideSourceOfFundsNotification | RenewAccreditationNotification | VerifyBankAccountNotification>;
  /** @deprecated use entity.registrationNumber */
  number?: Maybe<Scalars['String']['output']>;
  /** PIR only relevant to New Zealand-based Investing Entities */
  nzPrescribedInvestorRate?: Maybe<NzPrescribedInvestorRateBasisPoints>;
  /** The minimum this investing entity must meet on the given offer, or `null` if unavailable. */
  offerMinimum?: Maybe<OfferMinimum>;
  /** @deprecated use entity.partnershipType */
  partnershipType?: Maybe<Scalars['String']['output']>;
  /** List of permissions that the active account has for the investing entity */
  permissions?: Maybe<Array<Scalars['String']['output']>>;
  /** The total portfolio value of the investing entity */
  portfolioValue?: Maybe<Money>;
  reasonForInvesting?: Maybe<InvestingEntityReasonForInvesting>;
  relationshipEnum?: Maybe<InvestingEntityRelationship>;
  /** Search and return a list of documents from investment service for the active investing entity */
  searchDocuments: DocumentSearchResults;
  /** Search and return a list of transactions from transaction service for the active investing entity */
  searchTransactions: TransactionSearchResults;
  /** @deprecated use entity.natureAndPurposeDetails.sourceOfFunds */
  sourceOfFunds?: Maybe<SourceOfFundsSource>;
  /** @deprecated use entity.trustType */
  trustType?: Maybe<Scalars['String']['output']>;
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntityAllocationRequestArgs = {
  id: Scalars['ID']['input'];
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntityBankAccountsArgs = {
  isActiveAccount?: Scalars['Boolean']['input'];
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntityCanAccessOfferArgs = {
  offerId: Scalars['ID']['input'];
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntityNotificationArgs = {
  type: NotificationType;
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntityNotificationsArgs = {
  status?: InputMaybe<NotificationStatus>;
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntityOfferMinimumArgs = {
  offerId: Scalars['ID']['input'];
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntitySearchDocumentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filters?: InputMaybe<DocumentSearchFilters>;
  first: Scalars['Int']['input'];
  sort?: InputMaybe<DocumentSearchSort>;
};


/** Represents the entity under which an account is set up to invest. Either an individual, a company, a trust, or a joint-individual. */
export type InvestingEntitySearchTransactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  filters?: InputMaybe<TransactionSearchFilters>;
  first: Scalars['Int']['input'];
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<TransactionSearchSort>;
  tagsFilter?: InputMaybe<Array<TransactionTag>>;
  transactionTypes?: InputMaybe<Array<SearchTransactionType>>;
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export enum InvestingEntityAccountAccess {
  /** Full access to the investing entity */
  Full = 'FULL',
  /** Read-only access to the investing entity — view and download only, no writes */
  ReadOnly = 'READ_ONLY'
}

export enum InvestingEntityAvailableFunds {
  Between_50KAnd_250K = 'BETWEEN_50K_AND_250K',
  Between_250KAnd_1M = 'BETWEEN_250K_AND_1M',
  Over_1M = 'OVER_1M',
  Under_50K = 'UNDER_50K'
}

export enum InvestingEntityCompanyType {
  CompanyLimitedByGuarantee = 'COMPANY_LIMITED_BY_GUARANTEE',
  ForeignCompany = 'FOREIGN_COMPANY',
  IncorporatedAssociation = 'INCORPORATED_ASSOCIATION',
  LimitedCompany = 'LIMITED_COMPANY',
  NonProfit = 'NON_PROFIT',
  ProprietaryLimitedCompany = 'PROPRIETARY_LIMITED_COMPANY',
  PublicCompany = 'PUBLIC_COMPANY',
  SoleTrader = 'SOLE_TRADER',
  UnlimitedCompany = 'UNLIMITED_COMPANY'
}

export enum InvestingEntityFrequencyOfInvestment {
  /** This is synonymous to Ongoing Investment */
  MultipleOffers = 'MULTIPLE_OFFERS',
  OneOff = 'ONE_OFF'
}

/** A notification related to an investing entity */
export type InvestingEntityNotification = {
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export enum InvestingEntityPartnershipType {
  GeneralPartnership = 'GENERAL_PARTNERSHIP',
  LimitedPartnership = 'LIMITED_PARTNERSHIP'
}

export enum InvestingEntityReasonForInvesting {
  CapitalGrowth = 'CAPITAL_GROWTH',
  CapitalPreservation = 'CAPITAL_PRESERVATION',
  EstatePlanning = 'ESTATE_PLANNING',
  OngoingIncome = 'ONGOING_INCOME'
}

export enum InvestingEntityRelationship {
  AppointorOrProtector = 'APPOINTOR_OR_PROTECTOR',
  BearerAndNomineeShareholder = 'BEARER_AND_NOMINEE_SHAREHOLDER',
  BeneficiaryGreaterThan_25Percent = 'BENEFICIARY_GREATER_THAN_25_PERCENT',
  Director = 'DIRECTOR',
  GeneralPartner = 'GENERAL_PARTNER',
  LimitedPartnerGreaterThan_25Percent = 'LIMITED_PARTNER_GREATER_THAN_25_PERCENT',
  NomineeDirector = 'NOMINEE_DIRECTOR',
  NomineeShareholder = 'NOMINEE_SHAREHOLDER',
  NonDiscretionaryBeneficiary = 'NON_DISCRETIONARY_BENEFICIARY',
  OtherAuthorisedParty = 'OTHER_AUTHORISED_PARTY',
  Partner = 'PARTNER',
  ShareholdingVotingRightsGreaterThan_25Percent = 'SHAREHOLDING_VOTING_RIGHTS_GREATER_THAN_25_PERCENT',
  Trustee = 'TRUSTEE'
}

export enum InvestingEntityTrustType {
  CharitableTrust = 'CHARITABLE_TRUST',
  Discretionary = 'DISCRETIONARY',
  Estate = 'ESTATE',
  FamilyTrust = 'FAMILY_TRUST',
  GovernmentSuperannuationFund = 'GOVERNMENT_SUPERANNUATION_FUND',
  NonDiscretionary = 'NON_DISCRETIONARY',
  Other = 'OTHER',
  RegisteredManagedInvestmentScheme = 'REGISTERED_MANAGED_INVESTMENT_SCHEME',
  SelfManagedSuperFund = 'SELF_MANAGED_SUPER_FUND',
  SuperFundTrust = 'SUPER_FUND_TRUST',
  TestamentaryTrust = 'TESTAMENTARY_TRUST',
  TradingTrust = 'TRADING_TRUST',
  UnitTrust = 'UNIT_TRUST'
}

export enum InvestingEntityType {
  Company = 'COMPANY',
  Individual = 'INDIVIDUAL',
  JointIndividual = 'JOINT_INDIVIDUAL',
  Partnership = 'PARTNERSHIP',
  Trust = 'TRUST'
}

/** Contains an Account and InvestingEntity object */
export type Investor = {
  __typename: 'Investor';
  account: Account;
  investingEntity: InvestingEntity;
};

export type JointIndividualInvestingEntity = {
  __typename: 'JointIndividualInvestingEntity';
  /** Individual one */
  individualOne: IndividualInvestingEntity;
  /** Individual two */
  individualTwo: IndividualInvestingEntity;
  /** Name of the joint individual enitity */
  name?: Maybe<Scalars['String']['output']>;
};

export enum LiquidationReason {
  /** The holding's fund was exited */
  ExitedFund = 'EXITED_FUND',
  /** The holding was liquidated via the fund's secondary market */
  UnitsSold = 'UNITS_SOLD'
}

/**
 * The second factor a login challenge is to be satisfied by.
 *
 * Mirrors auth-service's MFAMethod. The proto's MFA_METHOD_UNSPECIFIED has no
 * member here: every enum in this schema omits the proto's zero value, and a
 * challenge that does not state a method is represented by a null field.
 */
export enum MfaMethod {
  Authenticator = 'AUTHENTICATOR',
  BackupCode = 'BACKUP_CODE',
  Email = 'EMAIL'
}

export type ManualAddressInput = {
  addressLine1: Scalars['String']['input'];
  /** Administrative area of the address (e.g. state, province, region) */
  administrativeArea?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  /** ISO 3166-1 alpha-2 country code of the address country */
  country: Scalars['String']['input'];
  postCode: Scalars['String']['input'];
  suburb?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Selects the documents to mark by search, mirroring the `Account.searchDocuments` arguments that scope a
 * search. Every member is optional; an empty filter matches everything that search returns unfiltered.
 */
export type MarkDocumentsViewedFilterInput = {
  /** The same entity, fund, unit class, category and read-state filters the search takes. */
  filters?: InputMaybe<DocumentSearchFiltersV2>;
  /** Search by keywords */
  keywords?: InputMaybe<Scalars['String']['input']>;
  /** Documents published on or after this date */
  publishDateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Documents published on or before this date */
  publishDateTo?: InputMaybe<Scalars['DateTime']['input']>;
};

/**
 * Selects the documents whose read-state changes, and the state to set. Exactly
 * one of `documentIds` or `filter` must be given.
 */
export type MarkDocumentsViewedInput = {
  /**
   * The ticked documents to mark, 1 to 250 of them. Either this or `filter` is
   * required, never both.
   */
  documentIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Every document matching this filter, for marking the whole current view. Either this or `documentIds` is
   * required, never both; a filter matching more than 5000 documents is rejected.
   */
  filter?: InputMaybe<MarkDocumentsViewedFilterInput>;
  /** True marks the documents viewed; false marks them unviewed. */
  viewed: Scalars['Boolean']['input'];
};

export type MarketingUnsubscribeResponse = {
  __typename: 'MarketingUnsubscribeResponse';
  result: MarketingUnsubscribeResult;
};

export enum MarketingUnsubscribeResult {
  AlreadyUnsubscribed = 'ALREADY_UNSUBSCRIBED',
  Unsubscribed = 'UNSUBSCRIBED'
}

/** Deprecated: To be removed */
export type MaybeVerifiableBankAccount = AudVerifiableBankAccount | BankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount;

/** Deprecated: Represents an amount of monetary value. */
export type Money = {
  __typename: 'Money';
  currency: Currency;
  name: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

/** Deprecated: To be removed */
export type MoneyAccount = AudVerifiableBankAccount | BankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount;

/** Represents a point in a chart */
export type MoneySeriesPoint = {
  __typename: 'MoneySeriesPoint';
  /** The date at the end of the time period that this point's value is for. */
  date: Scalars['DateTime']['output'];
  /** The value of the point. */
  value: Money;
};

export type Mutation = {
  __typename: 'Mutation';
  activateAccount?: Maybe<NewSession>;
  addInvestingEntityDocuments: InvestingEntity;
  beginIdentityVerification?: Maybe<BeginIdentityVerificationResponse>;
  /**
   * INVESTMENT: Atomically create one allocation request per investing entity in
   * the input against a single offer. The whole batch succeeds or fails together.
   */
  bulkCreateAllocationRequests: BulkCreateAllocationRequestPayload;
  /**
   * Bundles the requested documents into a single zip. Returns a presigned
   * S3 URL plus a list of documents that couldn't be included (e.g.
   * orphaned file pointers).
   *
   * Each entry takes the document's download name, and the archive is named
   * `Documents - {Account Full Name} - {YYYY-MM-DD}.zip`.
   */
  bulkDownloadDocuments: BulkDownloadDocumentsResult;
  /** Cross-entity variant of `bulkDownloadDocuments`. */
  bulkDownloadDocumentsV2: BulkDownloadDocumentsResult;
  completeAccountDetails?: Maybe<Account>;
  completeAccountIdentityVerification: Account;
  /** Complete contact details for beneficial owners */
  completeBeneficialOwnerContactDetails: InvestingEntity;
  completeBeneficialOwnerIdentityVerification: BeneficialOwner;
  completeUnauthenticatedAccountIdentityVerification: AccountFromToken;
  confirmAccreditation: InvestingEntity;
  confirmAuthenticatorEnrolment: BackupCodesPayload;
  /** @deprecated Deprecated to be removed once APP-7874 is complete */
  confirmBeneficialOwnerIdentityDocumentDetails: BeneficialOwner;
  createAccount?: Maybe<NewSession>;
  createAllocationRequest: AllocationRequest;
  /** Create a new bank account for an investing entity */
  createBankAccount: VerifiableBankAccountImpl;
  createCompanyInvestingEntity: NewSession;
  createIndividualInvestingEntity: NewSession;
  createJointIndividualInvestingEntity: NewSession;
  createPartnershipInvestingEntity: NewSession;
  createSessionFromToken?: Maybe<NewSession>;
  createSessionWithMFA?: Maybe<SessionWithMfaResponse>;
  createTrustInvestingEntity: NewSession;
  destroySession?: Maybe<StatusResponse>;
  disableAuthenticator: Scalars['Boolean']['output'];
  /** Generates a CSV of the account's distribution transactions */
  generateDistributionsCSV: RemoteAsset;
  /** Generates a CSV of the investing entity's transactions */
  generateTransactionsCSV: RemoteAsset;
  /**
   * Marks the documents selected by `documentIds` or `filter` as viewed or unviewed for the authenticated
   * account, which is resolved from the session. Read-state is per account, not per investing entity.
   */
  markDocumentsViewed: Scalars['Boolean']['output'];
  /** Place a buy order for a sell order */
  placeBuyOrder: SellOrder;
  /** Place a sell order for a holding */
  placeSellOrder: Holding;
  provideBasicAccountIdentityDetails: AccountFromToken;
  provideBeneficialOwnerBasicInformation: BeneficialOwner;
  provideSourceOfFunds?: Maybe<InvestingEntity>;
  /**
   * Records that an applicant has begun an application by selecting an investing
   * entity. The caller must hold update access on the target investing entity.
   * Idempotent, keyed on offer + authenticated account + investing entity: a
   * repeated call for that same triple records nothing further and returns
   * recorded: false.
   */
  recordApplicationStarted: RecordApplicationStartedPayload;
  /**
   * Records that the authenticated investor viewed the offer identified by
   * `slug`, so the Manager Console activity feed can show the view. The viewing
   * account is resolved from the session, never from the caller. Always returns
   * true; a failure arrives as an error, so it is never false.
   */
  recordOfferView: Scalars['Boolean']['output'];
  regenerateBackupCodes: BackupCodesPayload;
  /** Request a unit redemption */
  requestUnitRedemption: UnitRedemptionRequest;
  resendEmailConfirmation?: Maybe<StatusResponse>;
  resendMFAChallenge?: Maybe<ResendMfaChallengeResponse>;
  resetPassword?: Maybe<StatusResponse>;
  sendChangePasswordEmail?: Maybe<Account>;
  setNewPassword?: Maybe<NewSession>;
  setXplanDatafeedPassword: SetXplanDatafeedPasswordPayload;
  startAuthenticatorEnrolment: StartAuthenticatorEnrolmentPayload;
  switchInvestingEntity: NewSession;
  unsubscribeFromMarketing: MarketingUnsubscribeResponse;
  /** Update information about a bank account */
  updateBankAccount: AudVerifiableBankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount | VerifiableBankAccountImpl;
  updateCompanyInvestingEntity: InvestingEntity;
  updateEmailPreferences?: Maybe<Account>;
  updateFatcaCRS: InvestingEntity;
  /** Update information on a holding that is specific to this investor */
  updateHolding: Holding;
  updateIndividualInvestingEntity: InvestingEntity;
  /** Updates the default bank account for the specified investing entity */
  updateInvestingEntityDefaultBankAccount: InvestingEntity;
  updateInvestingEntityHoldingBankAccount: Holding;
  updateJointIndividualInvestingEntity: InvestingEntity;
  updatePartnershipInvestingEntity: InvestingEntity;
  updateProfile?: Maybe<Account>;
  updateTrustInvestingEntity: InvestingEntity;
  uploadAddressVerificationDocument?: Maybe<Account>;
  uploadBankAccountVerificationDocument: AudVerifiableBankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount | VerifiableBankAccountImpl;
  /** Upload a beneficial owner address document */
  uploadBeneficialOwnerAddressDocument: BeneficialOwner;
  /** Upload one file for an enabled document custom field. Persist each successful result immediately. On a lost response, replay the same attemptId, scope, filename and bytes; a changed payload is a new logical upload. Requires document-service product idempotency support before flag enablement. */
  uploadCustomFieldDocument: UploadedCustomFieldDocument;
  uploadInvestingEntityDocuments?: Maybe<Investor>;
  verifyMFAChallenge?: Maybe<NewSession>;
};


export type MutationActivateAccountArgs = {
  form: ActivateAccountInput;
};


export type MutationAddInvestingEntityDocumentsArgs = {
  form: AddInvestingEntityDocumentsInput;
};


export type MutationBeginIdentityVerificationArgs = {
  form: BeginIdentityVerificationInput;
};


export type MutationBulkCreateAllocationRequestsArgs = {
  input: BulkCreateAllocationRequestsInput;
};


export type MutationBulkDownloadDocumentsArgs = {
  input: BulkDownloadDocumentsInput;
};


export type MutationBulkDownloadDocumentsV2Args = {
  input: BulkDownloadDocumentsV2Input;
};


export type MutationCompleteAccountDetailsArgs = {
  form: AccountDetailsInput;
};


export type MutationCompleteAccountIdentityVerificationArgs = {
  form: CompleteAccountIdentityVerificationInput;
};


export type MutationCompleteBeneficialOwnerContactDetailsArgs = {
  form: CompleteBeneficialOwnerContactDetailsInput;
};


export type MutationCompleteBeneficialOwnerIdentityVerificationArgs = {
  form: CompleteBeneficialOwnerIdentityVerificationInput;
};


export type MutationCompleteUnauthenticatedAccountIdentityVerificationArgs = {
  form: CompleteAccountIdentityVerificationInput;
};


export type MutationConfirmAccreditationArgs = {
  form: ConfirmAccreditationInput;
};


export type MutationConfirmAuthenticatorEnrolmentArgs = {
  input: ConfirmAuthenticatorEnrolmentInput;
};


export type MutationConfirmBeneficialOwnerIdentityDocumentDetailsArgs = {
  form: ConfirmBeneficialOwnerIdentityDocumentDetailsInput;
};


export type MutationCreateAccountArgs = {
  account: CreateAccountInput;
};


export type MutationCreateAllocationRequestArgs = {
  form: CreateAllocationRequestInput;
};


export type MutationCreateBankAccountArgs = {
  form: CreateBankAccountInput;
};


export type MutationCreateCompanyInvestingEntityArgs = {
  form: CreateCompanyInvestingEntityInput;
};


export type MutationCreateIndividualInvestingEntityArgs = {
  form: CreateIndividualInvestingEntityInput;
};


export type MutationCreateJointIndividualInvestingEntityArgs = {
  form: CreateJointIndividualInvestingEntityInput;
};


export type MutationCreatePartnershipInvestingEntityArgs = {
  form: CreatePartnershipInvestingEntityInput;
};


export type MutationCreateSessionFromTokenArgs = {
  account: CreateSessionFromTokenInput;
};


export type MutationCreateSessionWithMfaArgs = {
  account: CreateSessionInput;
};


export type MutationCreateTrustInvestingEntityArgs = {
  form: CreateTrustInvestingEntityInput;
};


export type MutationDestroySessionArgs = {
  session: DestroySessionInput;
};


export type MutationDisableAuthenticatorArgs = {
  input: DisableAuthenticatorInput;
};


export type MutationGenerateDistributionsCsvArgs = {
  form: GenerateDistributionsCsvInput;
};


export type MutationGenerateTransactionsCsvArgs = {
  form: GenerateTransactionsCsvInput;
};


export type MutationMarkDocumentsViewedArgs = {
  form: MarkDocumentsViewedInput;
};


export type MutationPlaceBuyOrderArgs = {
  form: PlaceBuyOrderInput;
};


export type MutationPlaceSellOrderArgs = {
  form: PlaceSellOrderInput;
};


export type MutationProvideBasicAccountIdentityDetailsArgs = {
  form: ProvideBasicAccountIdentityDetailsInput;
};


export type MutationProvideBeneficialOwnerBasicInformationArgs = {
  form: ProvideBeneficialOwnerBasicInformationInput;
};


export type MutationProvideSourceOfFundsArgs = {
  form: ProvideSourceOfFundsInput;
};


export type MutationRecordApplicationStartedArgs = {
  input: RecordApplicationStartedInput;
};


export type MutationRecordOfferViewArgs = {
  slug: Scalars['ID']['input'];
};


export type MutationRegenerateBackupCodesArgs = {
  input: RegenerateBackupCodesInput;
};


export type MutationRequestUnitRedemptionArgs = {
  form: RequestUnitRedemptionInput;
};


export type MutationResendEmailConfirmationArgs = {
  account: ResendEmailConfirmationInput;
};


export type MutationResendMfaChallengeArgs = {
  account: ResendMfaChallengeInput;
};


export type MutationResetPasswordArgs = {
  account: ResetPasswordInput;
};


export type MutationSetNewPasswordArgs = {
  form: SetNewPasswordInput;
};


export type MutationStartAuthenticatorEnrolmentArgs = {
  input: StartAuthenticatorEnrolmentInput;
};


export type MutationSwitchInvestingEntityArgs = {
  form: SwitchInvestingEntityInput;
};


export type MutationUnsubscribeFromMarketingArgs = {
  token: Scalars['String']['input'];
};


export type MutationUpdateBankAccountArgs = {
  form: UpdateBankAccountInput;
};


export type MutationUpdateCompanyInvestingEntityArgs = {
  form: UpdateCompanyInvestingEntityInput;
};


export type MutationUpdateEmailPreferencesArgs = {
  form: UpdateEmailPreferencesInput;
};


export type MutationUpdateFatcaCrsArgs = {
  form: UpdateFatcaCrsInput;
};


export type MutationUpdateHoldingArgs = {
  form: UpdateHoldingInput;
};


export type MutationUpdateIndividualInvestingEntityArgs = {
  form: UpdateIndividualInvestingEntityInput;
};


export type MutationUpdateInvestingEntityDefaultBankAccountArgs = {
  form: UpdateInvestingEntityDefaultBankAccountInput;
};


export type MutationUpdateInvestingEntityHoldingBankAccountArgs = {
  form: UpdateInvestingEntityHoldingBankAccountInput;
};


export type MutationUpdateJointIndividualInvestingEntityArgs = {
  form: UpdateJointIndividualInvestingEntityInput;
};


export type MutationUpdatePartnershipInvestingEntityArgs = {
  form: UpdatePartnershipInvestingEntityInput;
};


export type MutationUpdateProfileArgs = {
  form: UpdateProfileInput;
};


export type MutationUpdateTrustInvestingEntityArgs = {
  form: UpdateTrustInvestingEntityInput;
};


export type MutationUploadAddressVerificationDocumentArgs = {
  form: UploadAddressVerificationDocumentInput;
};


export type MutationUploadBankAccountVerificationDocumentArgs = {
  form: UploadBankAccountVerificationDocumentInput;
};


export type MutationUploadBeneficialOwnerAddressDocumentArgs = {
  form: UploadBeneficialOwnerAddressDocumentInput;
};


export type MutationUploadCustomFieldDocumentArgs = {
  input: UploadCustomFieldDocumentInput;
};


export type MutationUploadInvestingEntityDocumentsArgs = {
  form: UploadInvestingEntityDocumentsInput;
};


export type MutationVerifyMfaChallengeArgs = {
  form: VerifyMfaChallengeInput;
};

export type MutationPermission = {
  __typename: 'MutationPermission';
  mutation: Scalars['String']['output'];
};

export type NzdVerifiableBankAccount = VerifiableBankAccount & {
  __typename: 'NZDVerifiableBankAccount';
  accountNumber: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  status: BankAccountStatus;
};

/** PIR assigned to New Zealand-based Investing Entities, in basis points */
export enum NzPrescribedInvestorRateBasisPoints {
  Rate_0 = 'RATE_0',
  Rate_144 = 'RATE_144',
  Rate_1050 = 'RATE_1050',
  Rate_1500 = 'RATE_1500',
  Rate_1750 = 'RATE_1750',
  Rate_2800 = 'RATE_2800',
  Rate_3000 = 'RATE_3000',
  Unset = 'UNSET'
}

export type NatureAndPurposeDetails = {
  __typename: 'NatureAndPurposeDetails';
  availableFunds?: Maybe<InvestingEntityAvailableFunds>;
  frequencyOfInvestment?: Maybe<InvestingEntityFrequencyOfInvestment>;
  reasonForInvesting?: Maybe<InvestingEntityReasonForInvesting>;
  sourceOfFunds?: Maybe<SourceOfFundsSource>;
};

export type NewInvestmentTransaction = Transaction & {
  __typename: 'NewInvestmentTransaction';
  amount: Money;
  /** @deprecated to be removed */
  from?: Maybe<MoneyAccount>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  pricePerUnit: Money;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Status is not yet supported in the new indexed transaction search */
  status: TransactionStatus;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling) */
  tags?: Maybe<Array<TransactionTag>>;
  to?: Maybe<Fund>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
};

/** Contains the Account and Session objects for the authenticated user. */
export type NewSession = {
  __typename: 'NewSession';
  account: Account;
  features: Array<FeatureFlag>;
  session: Session;
};


/** Contains the Account and Session objects for the authenticated user. */
export type NewSessionFeaturesArgs = {
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Represents a notification that can be sent to a user. */
export type Notification = {
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

/** The record a notification is associated with (the account itself, or one of its investing entities). */
export type NotificationAssociatedRecord = {
  __typename: 'NotificationAssociatedRecord';
  /** The identifier of the record. */
  id: Scalars['ID']['output'];
  /**
   * The investing entity this notification belongs to, present when the notification is scoped to an
   * investing entity (or one of its bank accounts). Null for account-level notifications.
   */
  investingEntity?: Maybe<InvestingEntity>;
  /** The kind of record this notification belongs to. */
  recipientType: RecipientType;
};

export enum NotificationStatus {
  Complete = 'COMPLETE',
  Incomplete = 'INCOMPLETE'
}

export enum NotificationType {
  AddBankAccount = 'ADD_BANK_ACCOUNT',
  AddInvestingEntity = 'ADD_INVESTING_ENTITY',
  ConfirmAccreditation = 'CONFIRM_ACCREDITATION',
  ConfirmEmailAddress = 'CONFIRM_EMAIL_ADDRESS',
  ConfirmIdentityDocumentDetails = 'CONFIRM_IDENTITY_DOCUMENT_DETAILS',
  ConfirmUnsupportedCountryAccreditation = 'CONFIRM_UNSUPPORTED_COUNTRY_ACCREDITATION',
  ProvideBeneficialOwnerContactDetails = 'PROVIDE_BENEFICIAL_OWNER_CONTACT_DETAILS',
  ProvideCityOfBirth = 'PROVIDE_CITY_OF_BIRTH',
  ProvideInvestingEntityDocuments = 'PROVIDE_INVESTING_ENTITY_DOCUMENTS',
  ProvideSourceOfFunds = 'PROVIDE_SOURCE_OF_FUNDS',
  ReattemptConfirmAccreditation = 'REATTEMPT_CONFIRM_ACCREDITATION',
  ReattemptProvideSourceOfFunds = 'REATTEMPT_PROVIDE_SOURCE_OF_FUNDS',
  ReattemptVerifyAddress = 'REATTEMPT_VERIFY_ADDRESS',
  ReattemptVerifyBiometricIdentity = 'REATTEMPT_VERIFY_BIOMETRIC_IDENTITY',
  RenewAccreditation = 'RENEW_ACCREDITATION',
  VerifyAddress = 'VERIFY_ADDRESS',
  VerifyBankAccount = 'VERIFY_BANK_ACCOUNT',
  VerifyBiometricIdentity = 'VERIFY_BIOMETRIC_IDENTITY'
}

export type OffMarketTransferTransaction = Transaction & {
  __typename: 'OffMarketTransferTransaction';
  amount: Money;
  fund?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated no longer required by FE */
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Status is not yet supported in the new indexed transaction search */
  status: TransactionStatus;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling) */
  tags?: Maybe<Array<TransactionTag>>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
  unitPrice: Money;
};

/** Describes an investable opportunity */
export type Offer = {
  __typename: 'Offer';
  applicationProgress?: Maybe<ApplicationProgress>;
  /** Capital-raise custom-field sections for the offer, including offer-scoped visibility */
  capitalRaiseCustomSections?: Maybe<Array<CapitalRaiseCustomSection>>;
  /** Whether advisers can capture an initial advice fee for this offer. */
  captureInitialAdviserFees: Scalars['Boolean']['output'];
  /** Whether advisers can capture an ongoing adviser service fee for this offer. */
  captureOngoingAdviserFees: Scalars['Boolean']['output'];
  cardImageUrl?: Maybe<Scalars['String']['output']>;
  /** Whether applications against this offer should collect adviser details. False hides the Investment Details step. */
  collectAdviserDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Whether applications against this offer should collect FATCA/CRS details */
  collectFatcaCrsDetails?: Maybe<Scalars['Boolean']['output']>;
  /** Collect reinvestment preferences for the offer */
  collectReinvestmentPreferences?: Maybe<Scalars['Boolean']['output']>;
  /** Whether applications against this offer should collect a wholesale certificate */
  collectWholesaleCertificate?: Maybe<Scalars['Boolean']['output']>;
  country: Country;
  /**
   * Custom field sections for the offer configured by the fund manager
   * @deprecated Use capitalRaiseCustomSections
   */
  customFieldSections?: Maybe<Array<CustomFieldSection>>;
  dataBlocks?: Maybe<Array<OfferTableBlock | OfferTextBlock>>;
  /** Key-value pairs, used to display short information on the hero page */
  details?: Maybe<Array<IndexedKeyValue>>;
  /** Whether the offer is available for digital subscription */
  digitalSubscription: OfferDigitalSubscription;
  documents?: Maybe<Array<Document>>;
  fund: Fund;
  fundsDeadline?: Maybe<Scalars['DateTime']['output']>;
  /** Used to filter offer from lists */
  hideOffer?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  /**
   * How the investor expresses an application against this raise: a dollar
   * amount, a number of units, or either. `null` when the raise has not declared
   * a method, whether the value is absent or reported as invalid. Clients should
   * keep their existing behaviour in that case.
   */
  investmentMethod?: Maybe<OfferInvestmentMethod>;
  /** Further information relating to the investor querying this offer. `null` if not authenticated */
  investor?: Maybe<OfferInvestor>;
  /** Type of investors this capital raise accepts. Null until the investor type path is released. */
  investorType?: Maybe<OfferInvestorType>;
  /**
   * Whether an investor must acknowledge that accreditation is required before
   * applying. Read from the raise's `investorType`, not from the fund: `WHOLESALE`
   * requires the acknowledgement, `RETAIL` does not, and a legacy raise with no
   * investor type recorded requires nothing.
   *
   * `WHOLESALE_RETAIL` reports `true`, which over-reports: the server requires the
   * acknowledgement from every applicant who has not declared retail, and a Boolean
   * cannot carry a per-applicant answer. A client that needs the correct answer for
   * a mixed raise should read `investorType` together with the type the applicant
   * declared, rather than this field.
   * @deprecated use investorType, which distinguishes a wholesale-retail raise from a wholesale one and so can be combined with the applicant's declared type. Removal eligible after: 2026-09-20
   */
  isAccreditationRequired: Scalars['Boolean']['output'];
  /** Whether applications must meet the minimum; when `false`, warn instead of blocking. */
  isMinimumEnforced: Scalars['Boolean']['output'];
  maxInvestmentHPM?: Maybe<HighPrecisionMoney>;
  /** The maximum number of units in this offer an investor can be allocated */
  maxUnitsPerInvestmentDecimal?: Maybe<FixedPointNumber>;
  minInvestmentHPM?: Maybe<HighPrecisionMoney>;
  /** The minimum number of units for an initial investment, or `null` if none. */
  minUnitsPerInvestmentDecimal?: Maybe<FixedPointNumber>;
  name: Scalars['String']['output'];
  openDate?: Maybe<Scalars['DateTime']['output']>;
  overview?: Maybe<Scalars['String']['output']>;
  /** The price of a single unit. `null` when this raise has no unit price set. */
  pricePerUnitHPM?: Maybe<HighPrecisionMoney>;
  /** @deprecated use primaryDocuments, which carries a primary document per document type. Removal eligible after: 2026-09-16 */
  primaryDocument?: Maybe<RemoteAsset>;
  /** Primary documents for this capital raise, at most one per document type. Null until the investor type path is released. */
  primaryDocuments?: Maybe<Array<OfferPrimaryDocument>>;
  /** Whether applications against this offer must answer all four Nature & Purpose questions. Honoured by the investor portal only when the tenant has the NATURE_AND_PURPOSE_RAISE_SETTING flag on. */
  requireNatureAndPurpose?: Maybe<Scalars['Boolean']['output']>;
  slug: Scalars['ID']['output'];
  status: OfferStatus;
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Total number of units in this offer */
  totalUnitCountDecimal?: Maybe<FixedPointNumber>;
  /** The unit class that is associated with this offer */
  unitClass?: Maybe<UnitClass>;
  videoUrl?: Maybe<Scalars['URL']['output']>;
};

export type OfferDataBlock = {
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export enum OfferDigitalSubscription {
  Disabled = 'DISABLED',
  Enabled = 'ENABLED'
}

/** How an investor expresses the value of an application against a capital raise. */
export enum OfferInvestmentMethod {
  /** The investor may apply with either a dollar amount or a number of units. */
  Both = 'BOTH',
  /** The investor applies with a dollar amount. */
  Dollars = 'DOLLARS',
  /** The investor applies with a number of units. */
  Units = 'UNITS'
}

/** Information relating to the (authenticated) investor who queried the offer */
export type OfferInvestor = {
  __typename: 'OfferInvestor';
  allocationRequests: Array<AllocationRequest>;
  hasRegisteredInterest: Scalars['Boolean']['output'];
  outstandingRequirementsToInvest: Array<OutstandingRequirementToInvest>;
};

/**
 * Type of investors a capital raise accepts.
 * Offer-scoped, unlike the fund-scoped `InvestorType`, so it can also carry both at once.
 */
export enum OfferInvestorType {
  /** Retail investors only */
  Retail = 'RETAIL',
  /** Wholesale/sophisticated investors only */
  Wholesale = 'WHOLESALE',
  /** Both wholesale and retail investors */
  WholesaleRetail = 'WHOLESALE_RETAIL'
}

/** The minimum an application must meet on an offer. */
export type OfferMinimum = {
  __typename: 'OfferMinimum';
  /** The minimum amount, or `null` if none. */
  minInvestmentHPM?: Maybe<HighPrecisionMoney>;
  /** The minimum number of units, or `null` if none. */
  minUnitsPerInvestmentDecimal?: Maybe<FixedPointNumber>;
};

/** A primary document for a capital raise, scoped to the kind of document it is */
export type OfferPrimaryDocument = {
  __typename: 'OfferPrimaryDocument';
  /** The document */
  document: RemoteAsset;
  /** The kind of document */
  documentType: OfferPrimaryDocumentType;
};

/**
 * The kind of primary document a capital raise carries.
 * Two-valued by design: a `WHOLESALE_RETAIL` raise carries one of each, never a single document serving both audiences.
 */
export enum OfferPrimaryDocumentType {
  /** The wholesale Information Memorandum */
  InformationMemorandum = 'INFORMATION_MEMORANDUM',
  /** The retail Product Disclosure Statement */
  ProductDisclosureStatement = 'PRODUCT_DISCLOSURE_STATEMENT'
}

export enum OfferStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type OfferTableBlock = OfferDataBlock & {
  __typename: 'OfferTableBlock';
  id: Scalars['ID']['output'];
  rows: Array<OfferTableBlockRow>;
  title: Scalars['String']['output'];
};

export type OfferTableBlockRow = {
  __typename: 'OfferTableBlockRow';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type OfferTextBlock = OfferDataBlock & {
  __typename: 'OfferTextBlock';
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type OptionalId = {
  value?: InputMaybe<Scalars['ID']['input']>;
};

export type OptionalString = {
  value?: InputMaybe<Scalars['String']['input']>;
};

/** A single order returned from a cross-entity order search. */
export type Order = {
  __typename: 'Order';
  /**
   * Adviser fee (initial and/or ongoing) captured against this order. Populated for
   * allocation orders only; null for all other order types and when no adviser fee
   * was captured.
   */
  adviserFee?: Maybe<AllocationAdviserFee>;
  /**
   * Monetary amount of the order, if any.
   * @deprecated Use requestedValue instead
   */
  amount?: Maybe<HighPrecisionMoney>;
  /** Date the order was created. */
  date: Scalars['DateTime']['output'];
  /** Fund associated with the order, if any. */
  fund?: Maybe<Fund>;
  /** Identifier of the holding associated with the order, if any. */
  holdingId?: Maybe<Scalars['ID']['output']>;
  /** Unique identifier of the order. */
  id: Scalars['ID']['output'];
  /** Investing entity the order belongs to. */
  investingEntity: InvestingEntity;
  /** Offer associated with the order, if any. */
  offer?: Maybe<Offer>;
  /**
   * The value the investor requested for this order. The concrete union type
   * (units, dollars, or percentage) indicates how the value is expressed. Null for
   * order types that carry no requested value (e.g. secondary-market and transfer
   * orders), or until the value has been hydrated.
   */
  requestedValue?: Maybe<OrderRequestedValue>;
  /** Investor-portal status bucket of the order. */
  status: OrderStatus;
  /** The kind of order. */
  type: OrderType;
  /** Unit class associated with the order, if any. */
  unitClass?: Maybe<UnitClass>;
};

/** A requested value expressed as a dollar amount. */
export type OrderDollarsRequestedValue = {
  __typename: 'OrderDollarsRequestedValue';
  /** Dollar amount the investor requested. */
  amount: HighPrecisionMoney;
};

/** An edge in a cross-entity order search result set. */
export type OrderEdge = {
  __typename: 'OrderEdge';
  /** Cursor for pagination. */
  cursor: Scalars['String']['output'];
  /** The order at this edge. */
  node: Order;
};

/** A requested value expressed as a percentage. Redemption orders only. */
export type OrderPercentageRequestedValue = {
  __typename: 'OrderPercentageRequestedValue';
  /** Percentage as a decimal string between 0 and 1 (e.g. "0.5" = 50%). */
  percentage: Scalars['String']['output'];
};

/**
 * The value an investor requested for an order. The concrete type is the
 * discriminator for how the value is expressed — there is no separate
 * calculation-method field. Allocations resolve to units or dollars; redemptions
 * may additionally resolve to a percentage.
 */
export type OrderRequestedValue = OrderDollarsRequestedValue | OrderPercentageRequestedValue | OrderUnitsRequestedValue;

/** Filters for a cross-entity order search. */
export type OrderSearchFilters = {
  /** Return orders with a transaction date on or after this date. (Note: filters on transaction date, while the displayed `Order.date` is the created date.) */
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  /** Return orders with a transaction date on or before this date. (Note: filters on transaction date, while the displayed `Order.date` is the created date.) */
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  /** Restrict results to these funds. */
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict results to these investing entities. Empty returns all entitled entities. */
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Restrict results to these order status buckets. */
  orderStatuses?: InputMaybe<Array<OrderStatus>>;
  /** Restrict results to these order types. */
  orderTypes?: InputMaybe<Array<OrderType>>;
  /** Restrict results to these unit classes. */
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/**
 * Filter options for an account's cross-entity order search, each derived from the
 * account's own orders so every option matches an order the portal shows.
 */
export type OrderSearchOptions = {
  __typename: 'OrderSearchOptions';
  /**
   * The distinct funds across the account's orders, for populating the Orders
   * Fund filter.
   */
  funds: Array<Fund>;
};

/** Paginated results for a cross-entity order search. */
export type OrderSearchResults = {
  __typename: 'OrderSearchResults';
  /** List of order edges. */
  edges: Array<OrderEdge>;
  /** Pagination information. */
  pageInfo: PageInfo;
};

/** Sort options for a cross-entity order search. */
export type OrderSearchSort = {
  /** Sort direction. */
  direction: SortDirection;
  /** Field to sort by. */
  field: OrderSearchSortField;
};

/** Fields an order search can be sorted by. */
export enum OrderSearchSortField {
  /** Sort by creation date. */
  CreatedAt = 'CREATED_AT',
  /** Sort by fund. */
  Fund = 'FUND',
  /** Sort by investing entity. */
  InvestingEntity = 'INVESTING_ENTITY',
  /** Sort by order type. */
  Type = 'TYPE',
  /** Sort by unit class. */
  UnitClass = 'UNIT_CLASS'
}

/**
 * The investor-portal status buckets for an order. These are display buckets
 * derived by jasper-api from the richer order status stored in the search index;
 * cancelled orders are excluded from search results entirely and so have no bucket.
 */
export enum OrderStatus {
  /** Order has been approved. */
  Approved = 'APPROVED',
  /** Order has completed. */
  Completed = 'COMPLETED',
  /** Order is awaiting action (requested, open, in buy-order review, or pending payment). */
  Pending = 'PENDING'
}

/** The kind of order returned by a cross-entity order search. */
export enum OrderType {
  /** A request to allocate into an offer. */
  AllocationRequest = 'ALLOCATION_REQUEST',
  /** A redemption order. */
  RedemptionOrder = 'REDEMPTION_ORDER',
  /** A secondary-market buy order. */
  SecondaryMarketBuyOrder = 'SECONDARY_MARKET_BUY_ORDER',
  /** A secondary-market sell order. */
  SecondaryMarketSellOrder = 'SECONDARY_MARKET_SELL_ORDER',
  /** A unit transfer request. */
  UnitTransferRequest = 'UNIT_TRANSFER_REQUEST'
}

/** A requested value expressed as a unit count. */
export type OrderUnitsRequestedValue = {
  __typename: 'OrderUnitsRequestedValue';
  /** Unit count as a decimal string. */
  units: Scalars['String']['output'];
};

export enum OutstandingRequirementToInvest {
  AccountSetupIncomplete = 'ACCOUNT_SETUP_INCOMPLETE',
  AcknowledgementOfAccreditationRequired = 'ACKNOWLEDGEMENT_OF_ACCREDITATION_REQUIRED',
  InvestingEntityIsRetailOnly = 'INVESTING_ENTITY_IS_RETAIL_ONLY',
  InvestingEntityRequired = 'INVESTING_ENTITY_REQUIRED'
}

/** Pagination provider */
export type PageInfo = {
  __typename: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type PartnershipInvestingEntity = {
  __typename: 'PartnershipInvestingEntity';
  /** Registered address of the partnership */
  address?: Maybe<Address>;
  /** Business number of the partnership */
  businessNumber?: Maybe<Scalars['String']['output']>;
  /** Get FATCA/CRS details for an investing entity, joint individual, or related party. Provide exactly one target. */
  fatcaCrsDetails?: Maybe<FatcaCrsDetails>;
  /** Unique identifier for this partnership investing entity. */
  id: Scalars['ID']['output'];
  /** Legal name of the partnership */
  name?: Maybe<Scalars['String']['output']>;
  /** Nature and purpose details for the partnership */
  natureAndPurposeDetails?: Maybe<NatureAndPurposeDetails>;
  /** partnership type */
  partnershipType?: Maybe<InvestingEntityPartnershipType>;
  /** Partnership Registration Number */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Entity tax details */
  taxDetails?: Maybe<EntityTaxDetails>;
};

export type Permissions = {
  __typename: 'Permissions';
  mutationPermissions: Array<MutationPermission>;
  typePermissions: Array<TypePermission>;
};

/** Represents a phone number attached to an account. */
export type PhoneNumber = {
  __typename: 'PhoneNumber';
  callingCode: Scalars['String']['output'];
  phoneNumber: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PhoneNumberInput = {
  callingCode: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type PlaceAddress = {
  __typename: 'PlaceAddress';
  /**
   * Administrative area of the address (e.g. state, province, region).
   * Only present on ADDRESS queries
   */
  administrativeArea?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  /** Only present on ADDRESS queries */
  line1?: Maybe<Scalars['String']['output']>;
  /** Only present on ADDRESS queries */
  postCode?: Maybe<Scalars['String']['output']>;
  /** Only present on ADDRESS queries */
  suburb?: Maybe<Scalars['String']['output']>;
};

export type PlaceBuyOrderInput = {
  /** The price per unit to buy at */
  bidPrice: Scalars['MoneyInput']['input'];
  /** ID of the sell order that the investor is placing a buy order for */
  sellOrderId: Scalars['ID']['input'];
};

/** Represents a place of birth. */
export type PlaceOfBirth = {
  __typename: 'PlaceOfBirth';
  city: Scalars['String']['output'];
  country: Country;
  id: Scalars['ID']['output'];
  placeId?: Maybe<Scalars['String']['output']>;
};

export type PlaceSellOrderInput = {
  /** Price per unit to sell at */
  askPrice: Scalars['MoneyInput']['input'];
  /** ID of the holding that the investor is requesting a sell order for */
  holdingId: Scalars['ID']['input'];
  unitCountDecimal?: InputMaybe<FixedPointNumberInput>;
};

/** Represents the portfolio of an investing entity. */
export type Portfolio = {
  __typename: 'Portfolio';
  /** Plot segments for 'Holding Holding Value'. */
  allocationsChartSegments: Array<PortfolioAllocationsChartSegment>;
  /** The remaining capital across all holdings. */
  capitalBalance: Money;
  /** The total amount of capital committed across all holdings. */
  capitalCommitted: Money;
  /** The total amount of capital deployed to acquire units across all holdings. */
  capitalContributed: Money;
  /** The total amount of capital paid out to investors via distributions flagged as capital (return of capital, capital gains, etc.), net of withholding, across all holdings. Excludes redemptions, secondary-market sales, and transfers out (see capitalReturned). */
  capitalDistributed: Money;
  /** The total capital gain/loss across all holdings. */
  capitalGain: Money;
  /** The total amount of capital returned to investors via redemptions, secondary-market sales, transfers out, and other unit-reducing transactions across all holdings. */
  capitalReturned: Money;
  /** The date that the portfolio was created - when the first units were issued to the investing entity across all holdings. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  holdingById?: Maybe<Holding>;
  /** The total estimated value of all holdings. */
  holdingValue: Money;
  holdings: Array<Holding>;
  /** The total amount of income returned to investors across all holdings. */
  incomeDistributed: Money;
  /** The investing entity this portfolio is scoped to. Null when resolved against the account's active investing entity. */
  investingEntityId?: Maybe<Scalars['ID']['output']>;
  /** True when the holdings that decide the reporting currency span multiple currencies, so reported values are FX-converted into reportingCurrency. Always false while the HOLDINGS_CURRENCY_ROLLUP flag is off for the tenant. */
  isCurrencyConverted: Scalars['Boolean']['output'];
  /** The date of the most recent distribution across all holdings. */
  lastDistributedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Configuration for the portfolio page */
  pageConfiguration: PortfolioPageConfiguration;
  portfolioOrders: Array<PortfolioOrder>;
  /** The currency every portfolio-level metric and chart on this portfolio reports in. Equals the tenant currency while the HOLDINGS_CURRENCY_ROLLUP flag is off for the tenant. */
  reportingCurrency: Currency;
  /**
   * Plot points for 'Portfolio Total Distributed'.
   * Refer to Caruso - Calculations for documentation. https://docs.google.com/document/d/1xIQBnp_f1e3am01uzA2O6HJNksIrcj3Jtylrju43NMs
   */
  totalDistributedPoints?: Maybe<Array<MoneySeriesPoint>>;
  /**
   * Plot points for 'Portfolio Holding Value'.
   * Refer to Caruso - Calculations for documentation. https://docs.google.com/document/d/1xIQBnp_f1e3am01uzA2O6HJNksIrcj3Jtylrju43NMs
   */
  totalValuePoints?: Maybe<Array<MoneySeriesPoint>>;
};


/** Represents the portfolio of an investing entity. */
export type PortfolioHoldingByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Represents the portfolio of an investing entity. */
export type PortfolioTotalDistributedPointsArgs = {
  periodEndExclusive: Scalars['DateTime']['input'];
  periodStartInclusive?: InputMaybe<Scalars['DateTime']['input']>;
  rollup?: InputMaybe<ChartRollup>;
  statistic?: InputMaybe<ChartAggregationStatistic>;
};


/** Represents the portfolio of an investing entity. */
export type PortfolioTotalValuePointsArgs = {
  periodEndExclusive: Scalars['DateTime']['input'];
  periodStartInclusive?: InputMaybe<Scalars['DateTime']['input']>;
  rollup?: InputMaybe<ChartRollup>;
  statistic?: InputMaybe<ChartAggregationStatistic>;
};

export type PortfolioAllocationsChartSegment = {
  __typename: 'PortfolioAllocationsChartSegment';
  /** The holding that this segment represents. */
  holding: Holding;
  /** The percentage of the portfolio that this holding represents. */
  proportionOfPortfolio: Fraction;
  /** The value of the holding, in the currency of the portfolio. */
  value: Money;
};

/** Possible key metric types to be displayed for an investor's portfolio. */
export enum PortfolioKeyMetricType {
  CapitalBalance = 'CAPITAL_BALANCE',
  CapitalCommitted = 'CAPITAL_COMMITTED',
  CapitalContributed = 'CAPITAL_CONTRIBUTED',
  CapitalDistributed = 'CAPITAL_DISTRIBUTED',
  CapitalGain = 'CAPITAL_GAIN',
  CapitalReturned = 'CAPITAL_RETURNED',
  CurrentHoldings = 'CURRENT_HOLDINGS',
  HoldingValue = 'HOLDING_VALUE',
  IncomeDistributed = 'INCOME_DISTRIBUTED',
  InvestedSince = 'INVESTED_SINCE',
  LastDistributionDate = 'LAST_DISTRIBUTION_DATE',
  TotalInvestments = 'TOTAL_INVESTMENTS'
}

export type PortfolioOrder = AllocationRequest | BuyOrder | SellOrder | UnitRedemptionRequest | UnitTransferRequest;

/** Configured modules for the portfolio page */
export type PortfolioPageConfiguration = {
  __typename: 'PortfolioPageConfiguration';
  /** Whether the fund manager has configured to show the allocations chart. */
  isAllocationsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured to show the capital commitments chart. */
  isCapitalCommitmentsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured to show the cumulative distributions chart. */
  isCumulativeDistributionsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured to show the holdings table. */
  isHoldingsTableShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured to show the recent distributions chart. */
  isRecentDistributionsChartShown: Scalars['Boolean']['output'];
  /** Whether the fund manager has configured to show the holding value chart. */
  isTotalValueChartShown: Scalars['Boolean']['output'];
  /** List of key metric types to be displayed, configured by the fund manager. */
  visibleKeyMetrics: Array<PortfolioKeyMetricType>;
};

export type ProvideBasicAccountIdentityDetailsInput = {
  /** If autocompleted, the residential address of the beneficial owner, either this or manualAddress is required */
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  dateOfBirth: DayMonthYearInput;
  firstName: Scalars['String']['input'];
  /** the id of the account to update */
  id: Scalars['ID']['input'];
  lastName: Scalars['String']['input'];
  /** If manually entered, the residential address of the beneficial owner, either this or autocompleteAddress is required */
  manualAddress?: InputMaybe<ManualAddressInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** pass the token from the email link to verify updating account details */
  token: Scalars['String']['input'];
};

export type ProvideBeneficialOwnerBasicInformationInput = {
  /** If autocompleted, the residential address of the beneficial owner, either this or manualAddress is required */
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  consent: Scalars['Boolean']['input'];
  dateOfBirth: DayMonthYearInput;
  /** FATCA/CRS details for the beneficial owner (individual fields only) */
  fatcaCrsDetails?: InputMaybe<BeneficialOwnerFatcaCrsDetailsInput>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  /** If manually entered, the residential address of the beneficial owner, either this or autocompleteAddress is required */
  manualAddress?: InputMaybe<ManualAddressInput>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Tax residencies for the beneficial owner. Send every field on every submit:
   * an omitted residency keeps whatever is already stored rather than clearing it.
   * A tax identification number read back from `BeneficialOwner.taxDetails` is
   * redacted, so never send a redacted value back here — omit the field instead.
   */
  taxDetails?: InputMaybe<BeneficialOwnerTaxDetailsInput>;
  token: Scalars['String']['input'];
};

export type ProvideBeneficialOwnerContactDetailsNotification = InvestingEntityNotification & Notification & {
  __typename: 'ProvideBeneficialOwnerContactDetailsNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ProvideCityOfBirthNotification = AccountNotification & Notification & {
  __typename: 'ProvideCityOfBirthNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ProvideInvestingEntityDocumentsNotification = InvestingEntityNotification & Notification & {
  __typename: 'ProvideInvestingEntityDocumentsNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ProvideSourceOfFundsInput = {
  document: Scalars['Upload']['input'];
  id: Scalars['ID']['input'];
  sourceOfFunds: SourceOfFundsSource;
  /** TODO: Make required once implemented. Explains how the document provided confirms the source of funds, max length 500 */
  supportingInformation?: InputMaybe<Scalars['String']['input']>;
};

export type ProvideSourceOfFundsNotification = InvestingEntityNotification & Notification & {
  __typename: 'ProvideSourceOfFundsNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type Query = {
  __typename: 'Query';
  /** Returns information about the logged in user */
  account?: Maybe<Account>;
  /** Returns information about an account from a token */
  accountFromToken?: Maybe<AccountFromToken>;
  /** Beneficial owner identity - Login not required */
  beneficialOwner: BeneficialOwner;
  /** Get list of beneficial owner contacts for this user's investing entity */
  beneficialOwnerContacts: Array<Maybe<BeneficialOwnerContact>>;
  /** Get a list of all available countries */
  countries: Array<Maybe<Country>>;
  /** Get a list of all available currencies */
  currencies: Array<Maybe<Currency>>;
  /** Get the currently enabled feature flags */
  features: Array<FeatureFlag>;
  /** Get a fund by slug */
  fund?: Maybe<Fund>;
  /** Funds available to the logged in user */
  funds: Array<Fund>;
  /** Get a list of addresses for a given placeId */
  geocodePlaceId?: Maybe<PlaceAddress>;
  /**
   * Returns a URL to download a zip of all documents matching the filters
   * @deprecated never supported
   */
  getDocumentArchiveDownloadUrl: Scalars['URL']['output'];
  /** Get an offer by slug */
  offer?: Maybe<Offer>;
  /** Available offers for the logged in user */
  offers: Array<Offer>;
  /** Permissions for the logged in user */
  permissions: Permissions;
  /**
   * The portfolio for a target investing entity. When investingEntityId is omitted,
   * falls back to the account's active investing entity (deprecated behaviour).
   */
  portfolio: Portfolio;
  /**
   * A signed token tying a proxy voting form response back to one investing
   * entity and meeting, passed to the form as a hidden field. The account must be
   * associated with investingEntityId.
   */
  proxyVotingToken: Scalars['String']['output'];
  /** Search for a list of addresses */
  searchAddress: AddressSearchResults;
  /** search in the company registry for a company */
  searchCompanies: Array<Maybe<CompanyResult>>;
  /** Query and return a paginated list of Distribution Transactions */
  searchDistributionTransactions: DistributionSearchTransactionResults;
  /** Get a sell order by slug */
  sellOrder?: Maybe<SellOrder>;
  /** Available secondary market sell orders */
  sellOrders: Array<SellOrder>;
  /** The current session of the logged in user */
  session?: Maybe<Session>;
  /** Logo and favicon URLs for the request tenant. Available before login. */
  tenantContentBrandAssets?: Maybe<TenantContentBrandAssets>;
  /** Tenant brand colours for the investor portal, scoped by X-Tenant-Id. Readable pre-login. */
  tenantContentColours: TenantContentColours;
  /** Tenant legal document links for the investor portal, scoped by X-Tenant-Id. Readable pre-login. */
  tenantContentLegalResources: TenantContentLegalResources;
  /** Tenant contact and identity details for the investor portal, scoped by X-Tenant-Id. Readable pre-login. */
  tenantContentOrganisationDetails: TenantContentOrganisationDetails;
  /** Tenant portal behaviour settings, scoped by X-Tenant-Id. Readable pre-login. */
  tenantContentPortalSettings: TenantContentPortalSettings;
  /** The tenant's selected terminology dictionary, scoped by X-Tenant-Id. Readable pre-login. */
  tenantContentTerminology: TenantContentTerminology;
};


export type QueryAccountFromTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryBeneficialOwnerArgs = {
  token: Scalars['String']['input'];
};


export type QueryFeaturesArgs = {
  flags?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryFundArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryGeocodePlaceIdArgs = {
  placeId: Scalars['String']['input'];
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetDocumentArchiveDownloadUrlArgs = {
  filters?: InputMaybe<DocumentSearchFilters>;
};


export type QueryOfferArgs = {
  slug: Scalars['ID']['input'];
};


export type QueryPortfolioArgs = {
  investingEntityId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryProxyVotingTokenArgs = {
  investingEntityId: Scalars['ID']['input'];
  meetingSlug: Scalars['String']['input'];
};


export type QuerySearchAddressArgs = {
  query: Scalars['String']['input'];
  searchType: AddressSearchType;
  sessionToken?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySearchCompaniesArgs = {
  countryId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


export type QuerySearchDistributionTransactionsArgs = {
  activeInvestingEntityId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  dateFrom?: InputMaybe<Scalars['DateTime']['input']>;
  dateTo?: InputMaybe<Scalars['DateTime']['input']>;
  distributionTransactionStatusFilter?: InputMaybe<Array<DistributionTransactionItemStatus>>;
  first: Scalars['Int']['input'];
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  keywords?: InputMaybe<Scalars['String']['input']>;
  sort?: InputMaybe<DistributionTransactionSearchSort>;
  unitClassIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySellOrderArgs = {
  id: Scalars['ID']['input'];
};

export type ReattemptConfirmAccreditationNotification = InvestingEntityNotification & Notification & {
  __typename: 'ReattemptConfirmAccreditationNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ReattemptProvideSourceOfFundsNotification = InvestingEntityNotification & Notification & {
  __typename: 'ReattemptProvideSourceOfFundsNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ReattemptVerifyAddressNotification = AccountNotification & Notification & {
  __typename: 'ReattemptVerifyAddressNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type ReattemptVerifyBiometricIdentityNotification = AccountNotification & Notification & {
  __typename: 'ReattemptVerifyBiometricIdentityNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

/** The kind of record a notification is associated with. */
export enum RecipientType {
  Account = 'ACCOUNT',
  InvestingEntity = 'INVESTING_ENTITY'
}

/**
 * Identifies the application start being recorded: the offer being applied for and
 * the investing entity the applicant selected to apply on behalf of. Both ids must
 * be positive signed 32-bit integers, and the caller must hold update access on the
 * investing entity. The applying account is never supplied here — it is resolved
 * from the authenticated session.
 */
export type RecordApplicationStartedInput = {
  /**
   * The investing entity the applicant selected to apply on behalf of. Must be a
   * positive signed 32-bit integer id; any other value is rejected as an invalid
   * argument. The caller must hold update access on this entity.
   */
  investingEntityId: Scalars['ID']['input'];
  /**
   * The offer the application is being made against. Must be a positive signed
   * 32-bit integer id; any other value is rejected as an invalid argument.
   */
  offerId: Scalars['ID']['input'];
};

/**
 * The outcome of recording that an application was started. Reports whether this
 * call was the one that created the record, since the operation is idempotent on
 * offer + authenticated account + investing entity.
 */
export type RecordApplicationStartedPayload = {
  __typename: 'RecordApplicationStartedPayload';
  /**
   * True when this call created the record and emitted the activity event. False
   * when a start was already recorded for the same offer, authenticated account
   * and investing entity, in which case nothing further was recorded. Because the
   * authenticated account is part of that key, a different account with access to
   * the same entity and offer still receives true on its own first call.
   */
  recorded: Scalars['Boolean']['output'];
};

/** Calculation method for a redemption request */
export enum RedemptionCalculationMethod {
  Dollars = 'DOLLARS',
  Percentage = 'PERCENTAGE',
  Units = 'UNITS'
}

export type RedemptionTransaction = Transaction & {
  __typename: 'RedemptionTransaction';
  amount: Money;
  fund?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated no longer required by FE */
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Status is not yet supported in the new indexed transaction search */
  status: TransactionStatus;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling) */
  tags?: Maybe<Array<TransactionTag>>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
  unitPrice: Money;
};

/** Issues a new set of backup codes and retires the previous set. */
export type RegenerateBackupCodesInput = {
  /** The account's current password, re-proved before the codes are replaced. */
  password: Scalars['String']['input'];
};

/** A remote file with the header Content-Disposition: Attachment. */
export type RemoteAsset = {
  __typename: 'RemoteAsset';
  contentType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  index: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type RenewAccreditationNotification = InvestingEntityNotification & Notification & {
  __typename: 'RenewAccreditationNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type RequestUnitRedemptionInput = {
  /** Calculation method for the redemption request */
  calculationMethod?: InputMaybe<RedemptionCalculationMethod>;
  /** ID of the holding that the investor is requesting a unit redemption for */
  holdingId: Scalars['ID']['input'];
  /** Number of units to redeem (required for legacy unit-based flow, optional when using calculationMethod) */
  unitCountDecimal?: InputMaybe<FixedPointNumberInput>;
  /** Requested value — interpretation depends on calculationMethod (unit count, dollar amount, or percentage as decimal e.g. 0.5 = 50%) */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ResendEmailConfirmationInput = {
  email: Scalars['String']['input'];
};

export type ResendMfaChallengeInput = {
  challengeToken: Scalars['String']['input'];
};

/** Contains a new MFA challenge token. */
export type ResendMfaChallengeResponse = {
  __typename: 'ResendMFAChallengeResponse';
  challengeToken: Scalars['String']['output'];
};

export type ResetPasswordInput = {
  email: Scalars['String']['input'];
};

export enum ResidentWithholdingTaxRateBasisPoints {
  Rate_0 = 'RATE_0',
  Rate_1050 = 'RATE_1050',
  Rate_1200 = 'RATE_1200',
  Rate_1500 = 'RATE_1500',
  Rate_1750 = 'RATE_1750',
  Rate_1900 = 'RATE_1900',
  Rate_2000 = 'RATE_2000',
  Rate_2200 = 'RATE_2200',
  Rate_2800 = 'RATE_2800',
  Rate_3000 = 'RATE_3000',
  Rate_3250 = 'RATE_3250',
  Rate_3300 = 'RATE_3300',
  Rate_3700 = 'RATE_3700',
  Rate_3900 = 'RATE_3900',
  Rate_4500 = 'RATE_4500',
  Rate_4700 = 'RATE_4700'
}

export type RetailOnlyAccreditation = Accreditation & {
  __typename: 'RetailOnlyAccreditation';
  country: Country;
  id: Scalars['ID']['output'];
  updated: Scalars['DateTime']['output'];
};

/** Types of transactions that can be searched */
export enum SearchTransactionType {
  /** Automatic reinvestment transaction */
  AutoReinvestment = 'AUTO_REINVESTMENT',
  /** New investment transaction */
  NewInvestment = 'NEW_INVESTMENT',
  /** Off-market transfer transaction */
  OffMarket = 'OFF_MARKET',
  /** Unit redemption transaction */
  Redemption = 'REDEMPTION',
  /** Secondary market unit purchase */
  SecondaryUnitPurchase = 'SECONDARY_UNIT_PURCHASE',
  /** Secondary market unit sale */
  SecondaryUnitSale = 'SECONDARY_UNIT_SALE'
}

export type SecondaryMarket = {
  __typename: 'SecondaryMarket';
  fees: Fraction;
  status: SecondaryMarketStatus;
};

export enum SecondaryMarketStatus {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type SecondaryUnitPurchaseTransaction = Transaction & {
  __typename: 'SecondaryUnitPurchaseTransaction';
  amount: Money;
  fund: Fund;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated no longer required by FE */
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Status is not yet supported in the new indexed transaction search */
  status: TransactionStatus;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling) */
  tags?: Maybe<Array<TransactionTag>>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
  unitPrice: Money;
};

export type SecondaryUnitSaleTransaction = Transaction & {
  __typename: 'SecondaryUnitSaleTransaction';
  amount: Money;
  fees?: Maybe<Money>;
  fund: Fund;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated no longer required by FE */
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Status is not yet supported in the new indexed transaction search */
  status: TransactionStatus;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling) */
  tags?: Maybe<Array<TransactionTag>>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
  unitPrice: Money;
};

export type SellOrder = {
  __typename: 'SellOrder';
  askPrice: Money;
  /** A buy order for the active investing entity on this sell order, if they have one */
  buyOrder?: Maybe<BuyOrder>;
  created: Scalars['DateTime']['output'];
  fees: Money;
  fund: Fund;
  id: Scalars['ID']['output'];
  netProceeds: Money;
  /**
   * The buy order just created by placeBuyOrder, as a unified cross-entity Order
   * sourced from the write itself (primary, consistent). Populated only on the
   * SellOrder returned from placeBuyOrder; null when a SellOrder is returned from
   * any other field.
   */
  order?: Maybe<Order>;
  status: SellOrderStatus;
  totalValue: Money;
  unitClass: UnitClass;
  unitCountDecimal: FixedPointNumber;
};

export enum SellOrderStatus {
  AwaitingTransfer = 'AWAITING_TRANSFER',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Open = 'OPEN',
  Requested = 'REQUESTED'
}

/** Represents an active user session authenticated and authorized by a JWT. */
export type Session = {
  __typename: 'Session';
  created: Scalars['DateTime']['output'];
  expires: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  /** Respresents an admin user who is acting on behalf of the account, null if the account holder is the user who logged in. */
  impersonatedBy?: Maybe<Admin>;
  token: Scalars['JWT']['output'];
};

/** Contains the Account and Session objects for the authenticated user. If MFA is required, the challenge ID is returned. */
export type SessionWithMfaResponse = {
  __typename: 'SessionWithMFAResponse';
  challengeToken?: Maybe<Scalars['String']['output']>;
  /** Which factor the challenge must be satisfied by. Null when MFA is not required, or when the challenge does not state a method — treat that as EMAIL. */
  mfaMethod?: Maybe<MfaMethod>;
  mfaRequired: Scalars['Boolean']['output'];
  session?: Maybe<NewSession>;
  success: Scalars['Boolean']['output'];
};

export type SetNewPasswordInput = {
  confirmPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

/** The plaintext Xplan datafeed password, shown exactly once. */
export type SetXplanDatafeedPasswordPayload = {
  __typename: 'SetXplanDatafeedPasswordPayload';
  /** The generated password. Store it now — it cannot be retrieved again. */
  password: Scalars['String']['output'];
  /** The adviser's Xplan Adviser Code (reference number). Enter this into Xplan alongside the password. */
  referenceNumber: Scalars['String']['output'];
  /** When this Xplan datafeed password was set. */
  setAt: Scalars['DateTime']['output'];
};

export type SkippedDocument = {
  __typename: 'SkippedDocument';
  documentId: Scalars['ID']['output'];
  reason: SkippedDocumentReason;
};

export enum SkippedDocumentReason {
  AccessDenied = 'ACCESS_DENIED',
  FileNotFound = 'FILE_NOT_FOUND',
  MetadataIncomplete = 'METADATA_INCOMPLETE',
  Unknown = 'UNKNOWN'
}

export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum SourceOfFundsSource {
  BusinessIncome = 'BUSINESS_INCOME',
  Gifts = 'GIFTS',
  Inheritances = 'INHERITANCES',
  InvestmentIncome = 'INVESTMENT_INCOME',
  LoanDrawdown = 'LOAN_DRAWDOWN',
  OtherIncome = 'OTHER_INCOME',
  RentalIncome = 'RENTAL_INCOME',
  SalaryAndWages = 'SALARY_AND_WAGES',
  /** This is synonymous to Sale of Asset */
  SaleOfProperty = 'SALE_OF_PROPERTY',
  SaleOfShares = 'SALE_OF_SHARES',
  Superannuation = 'SUPERANNUATION'
}

/**
 * Re-proves the account password before an enrolment starts. The session alone is
 * not enough: the portal keeps its token in localStorage, so enrolling an
 * attacker's authenticator would otherwise be one XSS away.
 */
export type StartAuthenticatorEnrolmentInput = {
  /** The account's current password, re-proved before the enrolment starts. */
  password: Scalars['String']['input'];
};

/**
 * The shared secret for a started enrolment. Returned once, before confirmation,
 * and never readable again. Both fields carry the same secret.
 */
export type StartAuthenticatorEnrolmentPayload = {
  __typename: 'StartAuthenticatorEnrolmentPayload';
  /** The otpauth:// URI, for rendering as a QR code. */
  otpauthUri: Scalars['String']['output'];
  /** The same shared secret in base32, for users who type it in by hand. */
  secret: Scalars['String']['output'];
};

/** Represents an active user session authenticated and authorized by a JWT. */
export type StatusResponse = {
  __typename: 'StatusResponse';
  message?: Maybe<Scalars['String']['output']>;
  statusCode?: Maybe<Scalars['Int']['output']>;
};

export type SwitchInvestingEntityInput = {
  /** ID of the investing entity we are switching to */
  id: Scalars['ID']['input'];
};

/** Deprecated: Tax attribution transactions are no longer supported via IP */
export type TaxAttributionTransaction = Transaction & {
  __typename: 'TaxAttributionTransaction';
  amount: Money;
  fund?: Maybe<Fund>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated no longer required by FE */
  reference?: Maybe<Scalars['String']['output']>;
  /** @deprecated Status is not yet supported in the new indexed transaction search */
  status: TransactionStatus;
  /** Tags applied to the transaction (null for this deprecated type) */
  tags?: Maybe<Array<TransactionTag>>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
  unitCountDecimal?: Maybe<FixedPointNumber>;
  unitPrice: Money;
};

/** Brand images rendered as uploaded, without cropping. */
export type TenantContentBrandAssets = {
  __typename: 'TenantContentBrandAssets';
  /** Light logo URL for dark backgrounds. Empty when unconfigured. Null when omitted by tenant-service. */
  logoReversedUrl?: Maybe<Scalars['String']['output']>;
  /** Logo URL. Empty when unconfigured. Null when omitted by tenant-service. */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /** Browser favicon URL. Empty when unconfigured. Null when omitted by tenant-service. */
  shortcutIconUrl?: Maybe<Scalars['String']['output']>;
};

/** Tenant brand colours for the investor portal content. */
export type TenantContentColours = {
  __typename: 'TenantContentColours';
  /** Primary brand colour */
  primary: Scalars['HexColorCode']['output'];
  /** UI theme */
  uiTheme: UiTheme;
};

/** Links to the tenant's legal documents, rendered in the portal. An uploaded document resolves to a file-service URL. */
export type TenantContentLegalResources = {
  __typename: 'TenantContentLegalResources';
  /** Privacy policy */
  privacyPolicyUrl: Scalars['String']['output'];
  /** Terms and conditions */
  termsAndConditionsUrl: Scalars['String']['output'];
  /** Wholesale certification document */
  wholesaleCertificationDocumentUrl: Scalars['String']['output'];
};

/** Contact and identity details for the tenant, rendered in the portal, emails and statements. */
export type TenantContentOrganisationDetails = {
  __typename: 'TenantContentOrganisationDetails';
  /** Postal address, rendered on statements */
  postalAddress: Scalars['String']['output'];
  /** Support email address */
  supportEmail: Scalars['String']['output'];
  /** Support phone number */
  supportPhone: Scalars['String']['output'];
  /** Portal footer link. http, https, mailto or tel */
  supportUrl: Scalars['String']['output'];
  /** Display name in the portal and in emails */
  tenantName: Scalars['String']['output'];
};

/** Portal behaviour a tenant is configured with. */
export type TenantContentPortalSettings = {
  __typename: 'TenantContentPortalSettings';
  /** Shows the prescribed-investor-rate form */
  collectPir: Scalars['Boolean']['output'];
  /** Shows the withholding-tax fields in portal forms */
  collectWht: Scalars['Boolean']['output'];
  /** ISO 3166 country. Null until an operator sets it */
  tenantCountry?: Maybe<Country>;
};

/**
 * The tenant's selection and resolved labels. Tenant-owned labels take precedence
 * over the shared library. An empty selection resolves to the default dictionary.
 * Labels are empty when a stored selection no longer resolves to a dictionary.
 */
export type TenantContentTerminology = {
  __typename: 'TenantContentTerminology';
  /** Adviser identifier label */
  adviserId?: Maybe<Scalars['String']['output']>;
  /** Business number label */
  businessNumber?: Maybe<Scalars['String']['output']>;
  /** Selected dictionary identifier. Empty when the tenant has picked none, even when default labels are returned. */
  dictionaryId: Scalars['String']['output'];
  /** Licence number label */
  licenceNumber?: Maybe<Scalars['String']['output']>;
  /** Manager business number label */
  managerBusinessNumber?: Maybe<Scalars['String']['output']>;
  /** Manager name label */
  managerName?: Maybe<Scalars['String']['output']>;
  /** Manager registration number label */
  managerRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Display name for the dictionary in the library */
  name?: Maybe<Scalars['String']['output']>;
  /** Non-resident withholding tax rate label */
  nonResidentWithholdingTaxRate?: Maybe<Scalars['String']['output']>;
  /** Prescribed investor rate label */
  prescribedInvestorRate?: Maybe<Scalars['String']['output']>;
  /** Primary tax identifier label */
  primaryTaxId?: Maybe<Scalars['String']['output']>;
  /** Registration number label */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Scheme number label */
  schemeNumber?: Maybe<Scalars['String']['output']>;
  /** Secondary tax identifier label */
  secondaryTaxId?: Maybe<Scalars['String']['output']>;
  /** Trustee business number label */
  trusteeBusinessNumber?: Maybe<Scalars['String']['output']>;
  /** Trustee licence number label */
  trusteeLicenceNumber?: Maybe<Scalars['String']['output']>;
  /** Trustee name label */
  trusteeName?: Maybe<Scalars['String']['output']>;
  /** Trustee registration number label */
  trusteeRegistrationNumber?: Maybe<Scalars['String']['output']>;
  /** Withholding tax rate label */
  withholdingTaxRate?: Maybe<Scalars['String']['output']>;
};

export type Transaction = {
  amount: Money;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  /** Tags applied to the transaction (e.g. Principal, Accrued Interest, Bonus Units, Stapling). Null if tags are not available for this transaction source. */
  tags?: Maybe<Array<TransactionTag>>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

export type TransactionEdge = {
  __typename: 'TransactionEdge';
  cursor: Scalars['String']['output'];
  node: AutoReInvestmentTransaction | DepositTransaction | DistributionPaymentTransaction | DistributionTransaction | FundExitTransaction | NewInvestmentTransaction | OffMarketTransferTransaction | RedemptionTransaction | SecondaryUnitPurchaseTransaction | SecondaryUnitSaleTransaction | TaxAttributionTransaction | WithdrawalTransaction;
};

export type TransactionSearchFilters = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** @deprecated use fundIds instead */
  fundId?: InputMaybe<Scalars['ID']['input']>;
  /** Funds to scope the search to. Empty means all funds. */
  fundIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  holdingId?: InputMaybe<Scalars['ID']['input']>;
  /** Investing entities to scope the search to. Empty means all of the account's investing entities; IDs outside the account are rejected. */
  investingEntityIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter transactions by tag/classification (e.g. only Accrued Interest). */
  tags?: InputMaybe<Array<TransactionTag>>;
  /** @deprecated use transactionTypes instead */
  transactionType?: InputMaybe<TransactionType>;
  transactionTypes?: InputMaybe<Array<TransactionType>>;
};

export type TransactionSearchResults = {
  __typename: 'TransactionSearchResults';
  edges: Array<TransactionEdge>;
  pageInfo: PageInfo;
};

/** Sort options for transaction search */
export type TransactionSearchSort = {
  /** Sort direction */
  direction: SortDirection;
  /** Field to sort by */
  field: TransactionSearchSortField;
};

/** Enum for transaction search sort fields */
export enum TransactionSearchSortField {
  /** Sort by amount */
  Amount = 'AMOUNT',
  /** Sort by date */
  Date = 'DATE',
  /** Sort by fund */
  Fund = 'FUND',
  /** Sort by id */
  Id = 'ID',
  /** Sort by number of units */
  NumUnits = 'NUM_UNITS',
  /** Sort by price per unit */
  PricePerUnit = 'PRICE_PER_UNIT',
  /** Sort by type */
  Type = 'TYPE',
  /** Sort by unit class */
  UnitClass = 'UNIT_CLASS'
}

export enum TransactionStatus {
  Complete = 'COMPLETE',
  Pending = 'PENDING'
}

/** Tags applied to a transaction. Surfaced to investors on the investor portal. */
export enum TransactionTag {
  AccruedInterest = 'ACCRUED_INTEREST',
  BonusUnits = 'BONUS_UNITS',
  Principal = 'PRINCIPAL',
  Stapling = 'STAPLING'
}

export enum TransactionType {
  AutoReinvestment = 'AUTO_REINVESTMENT',
  /** @deprecated Deposit transactions are not returned from the new indexed transaction search */
  Deposit = 'DEPOSIT',
  /** @deprecated Distribution transactions are not returned from the new indexed transaction search */
  Distribution = 'DISTRIBUTION',
  /** @deprecated Distribution payment transactions are not returned from the new indexed transaction search */
  DistributionPayment = 'DISTRIBUTION_PAYMENT',
  /** @deprecated Fund exit transactions are not returned from the new indexed transaction search */
  FundExit = 'FUND_EXIT',
  NewInvestment = 'NEW_INVESTMENT',
  OffMarket = 'OFF_MARKET',
  Redemption = 'REDEMPTION',
  SecondaryUnitPurchase = 'SECONDARY_UNIT_PURCHASE',
  SecondaryUnitSale = 'SECONDARY_UNIT_SALE',
  /** @deprecated Tax attribution transactions are no longer supported via IP */
  TaxAttribution = 'TAX_ATTRIBUTION',
  /** @deprecated Withdrawal transactions are not returned from the new indexed transaction search */
  Withdrawal = 'WITHDRAWAL'
}

export type TrustInvestingEntity = {
  __typename: 'TrustInvestingEntity';
  /** Registered address of the trust */
  address?: Maybe<Address>;
  /** Business number of the trust */
  businessNumber?: Maybe<Scalars['String']['output']>;
  /** Get FATCA/CRS details for an investing entity, joint individual, or related party. Provide exactly one target. */
  fatcaCrsDetails?: Maybe<FatcaCrsDetails>;
  /** Unique identifier for this trust investing entity. */
  id: Scalars['ID']['output'];
  /** Legal name of the trust */
  name?: Maybe<Scalars['String']['output']>;
  /** Nature and purpose details for the trust */
  natureAndPurposeDetails?: Maybe<NatureAndPurposeDetails>;
  /** Trust Registration Number */
  registrationNumber?: Maybe<Scalars['String']['output']>;
  /** Entity tax details */
  taxDetails?: Maybe<EntityTaxDetails>;
  /** trust type */
  trustType?: Maybe<InvestingEntityTrustType>;
};

export type TypePermission = {
  __typename: 'TypePermission';
  type: Scalars['String']['output'];
};

/** The visual theme a tenant's investor portal renders with. */
export enum UiTheme {
  Carbon = 'CARBON',
  Ember = 'EMBER',
  Moss = 'MOSS',
  Ocean = 'OCEAN'
}

export type UsdBankAccountBankAccountLocationDetails = {
  __typename: 'USDBankAccountBankAccountLocationDetails';
  /** Routing number for US bank accounts */
  routingNumber: Scalars['String']['output'];
};

export type UsdBankAccountInput = {
  routingNumber: Scalars['String']['input'];
};

export type UsdVerifiableBankAccount = VerifiableBankAccount & {
  __typename: 'USDVerifiableBankAccount';
  accountNumber: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  routingNumber: Scalars['String']['output'];
  status: BankAccountStatus;
};

export type UnitClass = {
  __typename: 'UnitClass';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  redemptionPrice?: Maybe<HighPrecisionMoney>;
  unitPrice?: Maybe<HighPrecisionMoney>;
  /** The valuation ("as at") date the latest unit price is effective from. Null when no unit price exists for the class. */
  unitPriceDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UnitRedemptionRequest = {
  __typename: 'UnitRedemptionRequest';
  /** Calculation method used for this redemption request */
  calculationMethod?: Maybe<RedemptionCalculationMethod>;
  /** Actual total amount — populated after batch confirm */
  completedAmount?: Maybe<HighPrecisionMoney>;
  /** Actual unit price at confirmation — populated after batch confirm */
  completedUnitPrice?: Maybe<HighPrecisionMoney>;
  /** Actual units redeemed — populated after batch confirm */
  completedUnits?: Maybe<FixedPointNumber>;
  created: Scalars['DateTime']['output'];
  holding: Holding;
  id: Scalars['ID']['output'];
  /**
   * The created redemption as a unified cross-entity Order, sourced from the write
   * itself (primary, consistent) so it is immediately consistent with the order
   * that created it. Populated when returned from requestUnitRedemption; null in
   * other contexts.
   */
  order?: Maybe<Order>;
  /** Requested value — unit count, dollar amount, or percentage depending on calculationMethod */
  requestedValue?: Maybe<Scalars['String']['output']>;
  status: UnitRedemptionStatus;
  /**
   * Deprecated: use completedAmount for confirmed values
   * @deprecated Use completedAmount instead
   */
  totalValue?: Maybe<HighPrecisionMoney>;
};

export enum UnitRedemptionStatus {
  Approved = 'APPROVED',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Requested = 'REQUESTED'
}

export type UnitTransferRequest = {
  __typename: 'UnitTransferRequest';
  created: Scalars['DateTime']['output'];
  fund: Fund;
  id: Scalars['ID']['output'];
  status: UnitTransferRequestStatus;
  totalValue: HighPrecisionMoney;
  unitClass: UnitClass;
  unitCountDecimal: FixedPointNumber;
  unitPriceV2: HighPrecisionMoney;
};

export enum UnitTransferRequestStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Requested = 'REQUESTED'
}

export type UpdateAddressInput = {
  /** Auto complete address of the individual */
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  /** Manual address of the individual */
  manualAddress?: InputMaybe<ManualAddressInput>;
};

export type UpdateBankAccountInput = {
  id: Scalars['ID']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCompanyInvestingEntityInput = {
  /** update address details for the company */
  address?: InputMaybe<UpdateAddressInput>;
  /** Business number of the company */
  businessNumber?: InputMaybe<OptionalString>;
  /** Company Registration Number */
  companyRegistrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** Company type */
  companyType?: InputMaybe<InvestingEntityCompanyType>;
  /** ID Of Investing Entity */
  id: Scalars['ID']['input'];
  /** nature and purpose details for the company */
  natureAndPurpose?: InputMaybe<UpdateNatureAndPurposeInput>;
  /** Tax details */
  taxDetails?: InputMaybe<UpdateTaxDetails>;
};

export type UpdateEmailPreferencesInput = {
  investmentOpportunities: Scalars['Boolean']['input'];
};

/** Input for updating FATCA/CRS details on an investing entity, joint individual, or related party. */
export type UpdateFatcaCrsInput = {
  /** Date of birth (for individuals only) */
  dateOfBirth?: InputMaybe<DayMonthYearInput>;
  /** FATCA/CRS details to update */
  fatcaCrsDetails: FatcaCrsDetailsInput;
  /** ID of the investing entity (required when targeting the primary entity or individual one in a joint account) */
  investingEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the second individual in a joint account (use individualTwo.id from JointIndividualInvestingEntity) */
  jointIndividualId?: InputMaybe<Scalars['ID']['input']>;
  /** ID of the related party / beneficial owner (required when targeting a related party) */
  relatedPartyId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateHoldingInput = {
  id: Scalars['ID']['input'];
};

export type UpdateIndividualInput = {
  /** Address of the individual */
  address?: InputMaybe<UpdateAddressInput>;
  /** nature and purpose details for the individual */
  natureAndPurpose?: InputMaybe<UpdateNatureAndPurposeInput>;
  /** Phone number of the individual */
  phoneNumber?: InputMaybe<PhoneNumberInput>;
  /** Place of birth details of the individual */
  placeOfBirthCity?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code of the place of birth */
  placeOfBirthCountryISOAlpha2?: InputMaybe<Scalars['String']['input']>;
  /** Google place ID of the place of birth */
  placeOfBirthPlaceId?: InputMaybe<Scalars['String']['input']>;
  /** Raw search string for the place of birth */
  placeOfBirthRawSearch?: InputMaybe<Scalars['String']['input']>;
  /** Primary citizenship of the individual */
  primaryCitizenshipId?: InputMaybe<Scalars['ID']['input']>;
  /** update the tax details for the individual */
  taxDetails?: InputMaybe<UpdateTaxDetails>;
};

export type UpdateIndividualInvestingEntityInput = {
  /** investing entity ID */
  id: Scalars['ID']['input'];
  /** individual */
  individual?: InputMaybe<UpdateIndividualInput>;
};

export type UpdateInvestingEntityDefaultBankAccountInput = {
  /** ID of the bank account */
  bankAccountId: Scalars['ID']['input'];
  /**
   * ID of the Investing entity to update default bank account for
   * @deprecated Token is used to identify the investing entity
   */
  investingEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** @deprecated Investors can no longer set default bank accounts themselves */
  isDefaultBankAccount?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateInvestingEntityHoldingBankAccountInput = {
  /** ID of the bank account to be used for the holding's distributions */
  bankAccountId: Scalars['ID']['input'];
  /** ID of the holding to update bank account for */
  holdingId: Scalars['ID']['input'];
  /** ID of the investing entity */
  id: Scalars['ID']['input'];
};

export type UpdateJointIndividualInvestingEntityInput = {
  /** investing entity ID */
  id: Scalars['ID']['input'];
  /** individual one */
  individualOne?: InputMaybe<UpdateIndividualInput>;
  /** individual two */
  individualTwo?: InputMaybe<UpdateIndividualInput>;
};

export type UpdateNatureAndPurposeInput = {
  /** Estimate of Funds Available for Investment */
  availableFunds?: InputMaybe<InvestingEntityAvailableFunds>;
  /** The frequency of investment expected from the Investing Entity */
  frequencyOfInvestment?: InputMaybe<InvestingEntityFrequencyOfInvestment>;
  /** The reason for investing */
  reasonForInvesting?: InputMaybe<InvestingEntityReasonForInvesting>;
  /** source of funds */
  sourceOfFunds?: InputMaybe<SourceOfFundsSource>;
};

export type UpdatePartnershipInvestingEntityInput = {
  /** update address details for the partnership */
  address?: InputMaybe<UpdateAddressInput>;
  /** Business number of the partnership */
  businessNumber?: InputMaybe<OptionalString>;
  /** id of the investing entity */
  id: Scalars['ID']['input'];
  /** nature and purpose details for the partnership */
  natureAndPurpose?: InputMaybe<UpdateNatureAndPurposeInput>;
  /** partnership type */
  partnershipType?: InputMaybe<InvestingEntityPartnershipType>;
  /** registration number of the partnership */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** tax details for the partnership */
  taxDetails?: InputMaybe<UpdateTaxDetails>;
};

export type UpdateProfileInput = {
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  callingCode?: InputMaybe<Scalars['String']['input']>;
  manualAddress?: InputMaybe<ManualAddressInput>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  preferredName?: InputMaybe<Scalars['String']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateTaxDetails = {
  /** RWT rate on interest */
  interestResidentWithholdingTax?: InputMaybe<ResidentWithholdingTaxRateBasisPoints>;
  /** NZ PIR */
  nzPrescribedInvestorRate?: InputMaybe<NzPrescribedInvestorRateBasisPoints>;
  /** Entity-service exemption reason for the primary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  primaryTaxExemptReason?: InputMaybe<OptionalString>;
  /** Primary tax identification number for the investing entity. */
  primaryTaxIdentificationNumber?: InputMaybe<OptionalString>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a primary tax resident. */
  primaryTaxResidencyCountryId?: InputMaybe<OptionalId>;
  /** Entity-service exemption reason for the secondary residency; AU reasons require Australian residency. Omission leaves the reason unchanged on updates. */
  secondaryTaxExemptReason?: InputMaybe<OptionalString>;
  /** Secondary tax identification number for the investing entity. */
  secondaryTaxIdentificationNumber?: InputMaybe<OptionalString>;
  /** ISO 3166-1 numeric-3 for the country where the investing entity is a secondary tax resident. */
  secondaryTaxResidencyCountryId?: InputMaybe<OptionalId>;
};

export type UpdateTrustInvestingEntityInput = {
  /** update address details for the trust */
  address?: InputMaybe<UpdateAddressInput>;
  /** Business number of the trust */
  businessNumber?: InputMaybe<OptionalString>;
  /** id of the investing entity */
  id: Scalars['ID']['input'];
  /** nature and purpose details for the individual */
  natureAndPurpose?: InputMaybe<UpdateNatureAndPurposeInput>;
  /** registration number of the trust (if applicable) */
  registrationNumber?: InputMaybe<Scalars['String']['input']>;
  /** tax details for the trust */
  taxDetails?: InputMaybe<UpdateTaxDetails>;
  /** trust type */
  trustType?: InputMaybe<InvestingEntityTrustType>;
};

export type UploadAddressVerificationDocumentInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code of the address country */
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  /** The following are required if any are present */
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressPlaceId?: InputMaybe<Scalars['String']['input']>;
  addressPostCode?: InputMaybe<Scalars['String']['input']>;
  /** To capture the raw input from the user, in case the search API results don't match */
  addressRawSearch?: InputMaybe<Scalars['String']['input']>;
  addressSuburb?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
};

export type UploadBankAccountVerificationDocumentInput = {
  accountNumber?: InputMaybe<Scalars['String']['input']>;
  bsbCode?: InputMaybe<Scalars['String']['input']>;
  file?: InputMaybe<Scalars['Upload']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
  routingNumber?: InputMaybe<Scalars['String']['input']>;
  sortCode?: InputMaybe<Scalars['String']['input']>;
};

export type UploadBeneficialOwnerAddressDocumentInput = {
  addressCity?: InputMaybe<Scalars['String']['input']>;
  /** ISO 3166-1 alpha-2 country code of the address country */
  addressCountry?: InputMaybe<Scalars['String']['input']>;
  addressLine1?: InputMaybe<Scalars['String']['input']>;
  addressPlaceId?: InputMaybe<Scalars['String']['input']>;
  addressPostCode?: InputMaybe<Scalars['String']['input']>;
  /** The following fields are deprecated - use autocompleteAddress or manualAddress */
  addressRawSearch?: InputMaybe<Scalars['String']['input']>;
  addressSuburb?: InputMaybe<Scalars['String']['input']>;
  /** The beneficial owner's residential address. If updating address & if updated via 'autocompletion', otherwise `null`. May not be provided in addition to manualAddress. */
  autocompleteAddress?: InputMaybe<AutocompleteAddressInput>;
  file: Scalars['Upload']['input'];
  /** The beneficial owner's residential address. If updating address & if updated via 'manual entry', otherwise `null`. May not be provided in addition to autocompleteAddress. */
  manualAddress?: InputMaybe<ManualAddressInput>;
  token: Scalars['String']['input'];
};

/** One selected document uploaded on Continue; send each file in its own request. */
export type UploadCustomFieldDocumentInput = {
  /** Non-zero UUID persisted before uploading; reuse with identical file bytes and filename on retry. */
  attemptId: Scalars['ID']['input'];
  /** Investor classification used to select the applicable custom sections. */
  declaredInvestorType?: InputMaybe<DeclaredInvestorType>;
  /** Document custom field ID within the section. */
  fieldId: Scalars['ID']['input'];
  /** One PDF, DOC, DOCX, JPG/JPEG, PNG or GIF, at most 52,428,800 bytes. */
  file: Scalars['Upload']['input'];
  /** The authorised investing entity that owns the document. */
  investingEntityId: Scalars['ID']['input'];
  /** Whether this is an advised application; adviser-hidden sections cannot receive uploads. */
  isAdvised?: InputMaybe<Scalars['Boolean']['input']>;
  /** Offer that configures this custom section. */
  offerId: Scalars['ID']['input'];
  /** Tenant custom section ID configured on the offer. */
  sectionId: Scalars['ID']['input'];
};

export type UploadInvestingEntityDocumentsInput = {
  files: Array<Scalars['Upload']['input']>;
  investingEntityId: Scalars['ID']['input'];
};

/** Metadata returned directly from a successful document-field upload, including an identical replay. */
export type UploadedCustomFieldDocument = {
  __typename: 'UploadedCustomFieldDocument';
  /** The client upload-attempt UUID; persist it before upload and reuse for identical retries. */
  attemptId: Scalars['ID']['output'];
  /** Original filename to persist with the document ID for same-browser resume. */
  filename: Scalars['String']['output'];
  /** Created document ID to submit as the custom-field answer value. */
  id: Scalars['ID']['output'];
};

export type VerifiableBankAccount = {
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  status: BankAccountStatus;
};

export type VerifiableBankAccountImpl = VerifiableBankAccount & {
  __typename: 'VerifiableBankAccountImpl';
  accountNumber: Scalars['String']['output'];
  bankAccountLocationDetails?: Maybe<BankAccountLocationDetails>;
  /** ISO 3166-1 numeric-3 of the country where the bank account is held. Null when entity-service has no country for the account */
  countryId?: Maybe<Scalars['ID']['output']>;
  created: Scalars['DateTime']['output'];
  currency: Currency;
  id: Scalars['ID']['output'];
  investingEntity: InvestingEntity;
  isDefaultAccount: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  nickname: Scalars['String']['output'];
  status: BankAccountStatus;
  swiftBic?: Maybe<Scalars['String']['output']>;
};

export type VerifyAddressNotification = AccountNotification & Notification & {
  __typename: 'VerifyAddressNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type VerifyBankAccountNotification = InvestingEntityNotification & Notification & {
  __typename: 'VerifyBankAccountNotification';
  bankAccount: VerifiableBankAccountImpl;
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type VerifyBiometricIdentityNotification = AccountNotification & Notification & {
  __typename: 'VerifyBiometricIdentityNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type VerifyIdentityNotification = AccountNotification & Notification & {
  __typename: 'VerifyIdentityNotification';
  id: Scalars['ID']['output'];
  sortOrder: Scalars['Int']['output'];
  status: NotificationStatus;
};

export type VerifyMfaChallengeInput = {
  answer: Scalars['String']['input'];
  challengeToken: Scalars['String']['input'];
  /**
   * Which factor the answer is being redeemed against. Optional: a client that
   * omits it gets the email flow, which is what every client sent before this
   * argument existed. A backup code is only compared as one when BACKUP_CODE is
   * named here.
   */
  method?: InputMaybe<MfaMethod>;
};

/** TODO: Break this implementation out into the specified types of 'wholesale' accreditation */
export type WholesaleAccreditation = Accreditation & {
  __typename: 'WholesaleAccreditation';
  certificateURL?: Maybe<Scalars['URL']['output']>;
  country: Country;
  /** @deprecated will be using certificateURL moving forward */
  document?: Maybe<HelloSignDocument>;
  id: Scalars['ID']['output'];
  signedAt?: Maybe<Scalars['DateTime']['output']>;
  status: AccreditationStatus;
  updated: Scalars['DateTime']['output'];
};

/** Deprecated: Withdrawal transactions are not returned from the new indexed transaction search */
export type WithdrawalTransaction = Transaction & {
  __typename: 'WithdrawalTransaction';
  amount: Money;
  /** @deprecated to be removed */
  from?: Maybe<MoneyAccount>;
  id: Scalars['ID']['output'];
  /** Investing entity that owns this transaction. Null if not available for this transaction source. */
  investingEntity?: Maybe<InvestingEntity>;
  processedAt?: Maybe<Scalars['DateTime']['output']>;
  reference?: Maybe<Scalars['String']['output']>;
  status: TransactionStatus;
  /** Tags applied to the transaction (null for this deprecated type) */
  tags?: Maybe<Array<TransactionTag>>;
  /** @deprecated to be removed */
  to?: Maybe<AudVerifiableBankAccount | EurVerifiableBankAccount | GbpVerifiableBankAccount | NzdVerifiableBankAccount | UsdVerifiableBankAccount | VerifiableBankAccountImpl>;
  /** unit class associated with the transaction */
  unitClass?: Maybe<UnitClass>;
};

/** Status of an adviser's Xplan datafeed password (never exposes the value). */
export type XplanDatafeedPasswordStatus = {
  __typename: 'XplanDatafeedPasswordStatus';
  /** Whether the adviser's datafeed access is not suspended. False only when the adviser is provisioned but disabled or blocked; a not-yet-provisioned adviser is active (they can generate a password to provision). */
  active: Scalars['Boolean']['output'];
  /** Whether this adviser can manage an Xplan datafeed password (has, or can be assigned, an Xplan Adviser Code). */
  canManage: Scalars['Boolean']['output'];
  /** Whether a password is currently set. */
  isSet: Scalars['Boolean']['output'];
  /** The adviser's Xplan Adviser Code, once assigned (by self-service or an admin). Null until a code has been assigned. */
  referenceNumber?: Maybe<Scalars['String']['output']>;
  /** When the current password was last set, if any. */
  setAt?: Maybe<Scalars['DateTime']['output']>;
};
